(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequireda16"];
var parcelRegister = parcelRequire.register;
parcelRegister("d8lRc", function(module, exports) {

$parcel$export(module.exports, "div", function () { return $98fcfa10876d4f3c$export$159d9494db57879b; });
$parcel$export(module.exports, "mod_", function () { return $98fcfa10876d4f3c$export$3f70e015da55297; });
function $98fcfa10876d4f3c$export$159d9494db57879b(x, y) {
    if (y === 0) throw {
        RE_EXN_ID: "Division_by_zero",
        Error: new Error()
    };
    return x / y | 0;
}
function $98fcfa10876d4f3c$export$3f70e015da55297(x, y) {
    if (y === 0) throw {
        RE_EXN_ID: "Division_by_zero",
        Error: new Error()
    };
    return x % y;
}
 /* No side effect */ 
});

parcelRegister("239BR", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $17e350db846948f9$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $fsiJD = parcelRequire("fsiJD");

var $aSJcu = parcelRequire("aSJcu");
function $17e350db846948f9$var$Prioritize2(Props) {
    var render = Props.render;
    var onPriorityChangeOpt = Props.onPriorityChange;
    var onPriorityChange = onPriorityChangeOpt !== undefined ? onPriorityChangeOpt : function onPriorityChange(p) {};
    var match = $aSJcu.use(undefined);
    var match$1 = match.windowSize;
    var vh = match$1.height;
    var vw = match$1.width;
    var match$2 = $g85JO.useState(function() {
        return false;
    });
    var setVisibleCoarse = match$2[1];
    var isVisibleCoarse = match$2[0];
    var match$3 = $g85JO.useState(function() {
        return false;
    });
    var setVisibleFine = match$3[1];
    var isVisibleFine = match$3[0];
    var priority = isVisibleCoarse ? isVisibleFine ? 0 : 1 : 2;
    $g85JO.useEffect(function() {
        $iv6Yc._1(onPriorityChange, priority);
    }, [
        priority
    ]);
    var offset_top = -vh | 0;
    var offset_left = -vw | 0;
    var offset_right = -vw | 0;
    var offset_bottom = -vh | 0;
    var offset = {
        top: offset_top,
        left: offset_left,
        right: offset_right,
        bottom: offset_bottom
    };
    var onChangeCoarse = function onChangeCoarse(nextIsVisible) {
        if (!isVisibleCoarse && nextIsVisible) return $iv6Yc._1(setVisibleCoarse, function(param) {
            return true;
        });
    };
    var onChangeFine = function onChangeFine(nextIsVisible) {
        if (!isVisibleFine && nextIsVisible) return $iv6Yc._1(setVisibleFine, function(param) {
            return true;
        });
    };
    var children = $iv6Yc._1(render, priority);
    return /*#__PURE__*/ $g85JO.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fsiJD))), {
        partialVisibility: true,
        onChange: onChangeCoarse,
        children: /*#__PURE__*/ $g85JO.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fsiJD))), {
            partialVisibility: true,
            onChange: onChangeFine,
            children: children
        }),
        offset: offset
    });
}
$17e350db846948f9$var$Prioritize2.displayName = "Prioritize2";
var $17e350db846948f9$export$dd44f18ab656f3bb = $17e350db846948f9$var$Prioritize2;
 /* react Not a pure module */ 
});

parcelRegister("diVVk", function(module, exports) {

$parcel$export(module.exports, "Size", function () { return $9af9e34078600d7a$export$cb6da89c6af1a8ec; });
$parcel$export(module.exports, "make", function () { return $9af9e34078600d7a$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $cHs0A = parcelRequire("cHs0A");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $tUpyX = parcelRequire("tUpyX");

var $1xf0g = parcelRequire("1xf0g");

var $iXXhl = parcelRequire("iXXhl");

var $gCzsf = parcelRequire("gCzsf");

var $5bEXW = parcelRequire("5bEXW");

var $5av24 = parcelRequire("5av24");

var $dtaxl = parcelRequire("dtaxl");

var $k0ukS = parcelRequire("k0ukS");

var $aSJcu = parcelRequire("aSJcu");
function $9af9e34078600d7a$var$getRatio(ratio) {
    if (typeof ratio !== "number") return ratio._0 / ratio._1;
    switch(ratio){
        case /* Circle */ 0:
        case /* Square */ 1:
            return 1;
        case /* Landscape */ 2:
            return 4 / 3;
        case /* Portrait */ 3:
            return 2 / 3;
        case /* Panorama */ 4:
            return 21 / 9;
        case /* Wide */ 5:
            return 16 / 9;
        case /* Tall */ 6:
            return 9 / 16;
    }
}
function $9af9e34078600d7a$var$getColumns(columns) {
    switch(columns){
        case /* OneColumnGrid */ 0:
            return 1;
        case /* TwoColumnGrid */ 1:
            return 2;
        case /* ThreeColumnGrid */ 2:
            return 3;
        case /* FourColumnGrid */ 3:
            return 4;
        case /* FiveColumnGrid */ 4:
            return 5;
        case /* SixColumnGrid */ 5:
            return 6;
        case /* SevenColumnGrid */ 6:
            return 7;
        case /* EightColumnGrid */ 7:
            return 8;
        case /* TwelveColumnGrid */ 8:
            return 12;
    }
}
function $9af9e34078600d7a$var$estimateCardSize(containerWidth, layout, productLayout, cardSize, cardShape, theme) {
    var columns = layout ? $9af9e34078600d7a$var$getColumns(productLayout) : $1xf0g.CardSize.getSlidesPerView(cardSize);
    var horizontalGap = $2whNH.getWithDefault($cHs0A.fromString(theme.columnGutter), 12);
    var width = containerWidth / columns - horizontalGap;
    var height = width / $9af9e34078600d7a$var$getRatio(cardShape);
    return [
        width | 0,
        height | 0
    ];
}
function $9af9e34078600d7a$var$estimateSectionSize(containerWidth, layout, productLayout, cardSize, cardShape, count, theme) {
    var columns = layout ? $9af9e34078600d7a$var$getColumns(productLayout) : $1xf0g.CardSize.getSlidesPerView(cardSize);
    var rows = layout ? Math.ceil(count / columns) | 0 : 1;
    var match = $9af9e34078600d7a$var$estimateCardSize(containerWidth, layout, productLayout, cardSize, cardShape, theme);
    var height = Math.imul(match[1], rows);
    return [
        match[0],
        height
    ];
}
var $9af9e34078600d7a$export$cb6da89c6af1a8ec = {
    getRatio: $9af9e34078600d7a$var$getRatio,
    getColumns: $9af9e34078600d7a$var$getColumns,
    estimateCardSize: $9af9e34078600d7a$var$estimateCardSize,
    estimateSectionSize: $9af9e34078600d7a$var$estimateSectionSize
};
function $9af9e34078600d7a$export$800234e4db8eab83(textSize) {
    switch(textSize){
        case /* Xl */ 0:
            return "text-xl";
        case /* Lg */ 1:
            return "text-lg";
        case /* Base */ 2:
            return "text-base";
    }
}
function $9af9e34078600d7a$var$Card(Props) {
    var shapeOpt = Props.shape;
    var fluidOpt = Props.fluid;
    var id = Props.id;
    var nodeId = Props.nodeId;
    var link = Props.link;
    var preventLinkDefaultOpt = Props.preventLinkDefault;
    var lineClamp = Props.lineClamp;
    var titleTextSizeDesktopOpt = Props.titleTextSizeDesktop;
    var titleTextSizeMobileOpt = Props.titleTextSizeMobile;
    var showTitleOpt = Props.showTitle;
    var openLinkInNewTabOpt = Props.openLinkInNewTab;
    var selectedOpt = Props.selected;
    var inspectable = Props.inspectable;
    var roundedOpt = Props.rounded;
    var classNameOpt = Props.className;
    var title = Props.title;
    var contentBoxStylableClassName = Props.contentBoxStylableClassName;
    var titleStylableClassName = Props.titleStylableClassName;
    var imageSize = Props.imageSize;
    var fwdRef = Props.fwdRef;
    var dataTestId = Props.dataTestId;
    var dataCount = Props.dataCount;
    var titleDataTestId = Props.titleDataTestId;
    var renderTitle = Props.renderTitle;
    var childrenOpt = Props.children;
    var renderBeforeTitle = Props.renderBeforeTitle;
    var renderAfterTitle = Props.renderAfterTitle;
    var renderOverlay = Props.renderOverlay;
    var style = Props.style;
    var onClickDiv = Props.onClickDiv;
    var onClickLink = Props.onClickLink;
    var onHoverOpt = Props.onHover;
    var onMouseLeaveOpt = Props.onMouseLeave;
    var shape = shapeOpt !== undefined ? shapeOpt : /* Square */ 1;
    var fluid = fluidOpt !== undefined ? fluidOpt : false;
    var preventLinkDefault = preventLinkDefaultOpt !== undefined ? preventLinkDefaultOpt : false;
    var titleTextSizeDesktop = titleTextSizeDesktopOpt !== undefined ? titleTextSizeDesktopOpt : /* Xl */ 0;
    var titleTextSizeMobile = titleTextSizeMobileOpt !== undefined ? titleTextSizeMobileOpt : /* Lg */ 1;
    var showTitle = showTitleOpt !== undefined ? showTitleOpt : true;
    var openLinkInNewTab = openLinkInNewTabOpt !== undefined ? openLinkInNewTabOpt : false;
    var selected = selectedOpt !== undefined ? selectedOpt : false;
    var rounded = roundedOpt !== undefined ? roundedOpt : true;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var children = childrenOpt !== undefined ? $loT9g.valFromOption(childrenOpt) : null;
    var onHover = onHoverOpt !== undefined ? onHoverOpt : function onHover(param) {};
    var onMouseLeave = onMouseLeaveOpt !== undefined ? onMouseLeaveOpt : function onMouseLeave(param) {};
    var ref = $g85JO.useRef(null);
    var ref$1 = fwdRef !== undefined ? (0, $iXXhl.default)(ref, fwdRef) : ref;
    var href;
    if (link !== undefined && link.TAG === /* URL */ 0) {
        var href$1 = link._0;
        href = href$1.trim() !== "" ? href$1 : undefined;
    } else href = undefined;
    var match = $aSJcu.use(undefined);
    var isMobile = match.isMobile;
    var tmp;
    if (typeof shape === "number") switch(shape){
        case /* Circle */ 0:
        case /* Square */ 1:
            tmp = "aspect-ratio-square";
            break;
        case /* Landscape */ 2:
            tmp = "aspect-ratio-4/3";
            break;
        case /* Portrait */ 3:
            tmp = "aspect-ratio-2/3";
            break;
        case /* Panorama */ 4:
            tmp = "aspect-ratio-21/9";
            break;
        case /* Wide */ 5:
            tmp = "aspect-ratio-16/9";
            break;
        case /* Tall */ 6:
            tmp = "aspect-ratio-9/16";
            break;
    }
    else tmp = "";
    var aspectRatioCn = $ezf3v.prefix(tmp);
    var aspectRatioCn$1 = fluid ? $ezf3v.prefix("h-full") : aspectRatioCn;
    var aspectRatioStyle;
    if (typeof shape === "number") aspectRatioStyle = undefined;
    else {
        var h = shape._1;
        var w = shape._0;
        if (w === 0 && h === 0) {
            var w$1 = $2whNH.getWithDefault(imageSize[0], 0);
            var h$1 = $2whNH.getWithDefault(imageSize[1], 0);
            aspectRatioStyle = {
                paddingBottom: $ezf3v.floatToPercentage(h$1 / w$1 * 100.0)
            };
        } else aspectRatioStyle = fluid ? undefined : {
            paddingBottom: $ezf3v.floatToPercentage(h / w * 100.0)
        };
    }
    var roundedCn = shape === 0 ? $ezf3v.prefix("rounded-full") : rounded ? $ezf3v.prefix("rounded-custom") : "";
    var safariFixCn = $ezf3v.prefix("clip-path-margin");
    var textAlignCn = shape === 0 ? "text-center" : "text-left";
    var pressedCn = $ezf3v.prefix(isMobile ? "scale-100 active:scale-97 transition-transform duration-150" : "");
    var handleMouseOver = function handleMouseOver(param) {
        $iv6Yc._1(onHover, undefined);
    };
    var defaultTitleRenderer = function defaultTitleRenderer(title) {
        var labelTextSize = isMobile ? $9af9e34078600d7a$export$800234e4db8eab83(titleTextSizeMobile) : $9af9e34078600d7a$export$800234e4db8eab83(titleTextSizeDesktop);
        var labelJustify = shape === 0 ? "justify-center" : "justify-start";
        var labelClassName = $ezf3v.prefix($1TRFX.make([
            "pt-2 font-medium text-primary flex items-start space-x-2",
            labelTextSize,
            labelJustify
        ]));
        var tmp = {
            lines: lineClamp,
            children: /*#__PURE__*/ $g85JO.createElement($k0ukS.make, {
                className: titleStylableClassName,
                children: title
            })
        };
        if (titleDataTestId !== undefined) tmp.dataTestId = $loT9g.valFromOption(titleDataTestId);
        return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "flex-grow-1 leading-normal relative",
                textAlignCn
            ]))
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: labelClassName
        }, /*#__PURE__*/ $g85JO.createElement($5av24.make, tmp)));
    };
    var renderTitle$1 = function renderTitle$1(param) {
        if (title !== undefined) {
            if (renderTitle !== undefined) {
                if (showTitle) return $iv6Yc._1(renderTitle, defaultTitleRenderer(title));
                else return null;
            } else if (showTitle) return defaultTitleRenderer(title);
            else return null;
        } else if (renderTitle !== undefined && showTitle) return $iv6Yc._1(renderTitle, null);
        else return null;
    };
    var cursor = href !== undefined || onClickDiv !== undefined || onClickLink !== undefined ? $ezf3v.prefix("cursor-pointer") : $ezf3v.prefix("cursor-default");
    var selectionBorder = selected ? /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute -inset-1 border border-solid rounded-custom pointer-events-none border-accent")
    }) : null;
    var tmp$1 = {
        id: id,
        className: $ezf3v.prefix(fluid ? "flex-grow" : ""),
        children: null
    };
    if (inspectable !== undefined) tmp$1.kind = $loT9g.valFromOption(inspectable);
    if (nodeId !== undefined) tmp$1.nodeId = nodeId;
    var tmp$2 = {
        className: $1TRFX.make([
            $ezf3v.prefix("w-full relative overflow-hidden flex-grow-0"),
            aspectRatioCn$1,
            roundedCn,
            pressedCn,
            safariFixCn
        ])
    };
    if (aspectRatioStyle !== undefined) tmp$2.style = $loT9g.valFromOption(aspectRatioStyle);
    var content = /*#__PURE__*/ $g85JO.createElement($dtaxl.make, tmp$1, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "relative",
            fluid ? "h-full" : ""
        ])),
        id: id
    }, /*#__PURE__*/ $g85JO.createElement("div", tmp$2, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "absolute",
            "flex items-center justify-center",
            "w-full h-full"
        ]))
    }, children), $2whNH.mapWithDefault(renderOverlay, null, function(renderOverlay) {
        return $iv6Yc._1(renderOverlay, undefined);
    }))), /*#__PURE__*/ $g85JO.createElement($k0ukS.make, {
        className: contentBoxStylableClassName,
        children: null
    }, $2whNH.mapWithDefault($2whNH.flatMap(renderBeforeTitle, function(render) {
        return $iv6Yc._1(render, undefined);
    }), null, function(el) {
        return el;
    }), renderTitle$1(undefined), $2whNH.mapWithDefault($2whNH.flatMap(renderAfterTitle, function(render) {
        return $iv6Yc._1(render, undefined);
    }), null, function(el) {
        return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("mt-2")
        }, el);
    })));
    var children$1 = /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, content, selectionBorder);
    if (href !== undefined) {
        var tmp$3 = {
            children: children$1,
            href: href,
            fwdRef: $5bEXW.Ref.domRef(ref$1),
            disabled: preventLinkDefault,
            unstyled: true,
            className: $1TRFX.make([
                $ezf3v.prefix("!flex !no-underline"),
                $ezf3v.prefix("flex-col leading-0 group-2 relative no-touch-highlight"),
                fluid ? $ezf3v.prefix("h-full") : "",
                cursor,
                className
            ]),
            openLinkInNewTab: openLinkInNewTab,
            data: id,
            onMouseOver: handleMouseOver,
            onMouseLeave: onMouseLeave
        };
        if (style !== undefined) tmp$3.style = $loT9g.valFromOption(style);
        if (title !== undefined) tmp$3.ariaLabel = $loT9g.valFromOption(title);
        if (dataTestId !== undefined) tmp$3.dataTestId = $loT9g.valFromOption(dataTestId);
        if (dataCount !== undefined) tmp$3.dataCount = dataCount;
        if (onClickLink !== undefined) tmp$3.onClick = $loT9g.valFromOption(onClickLink);
        return /*#__PURE__*/ $g85JO.createElement($tUpyX.make, tmp$3);
    }
    var tmp$4 = {
        ref: $5bEXW.Ref.domRef(ref$1),
        className: $1TRFX.make([
            $ezf3v.prefix("flex flex-col no-underline leading-0 group-2 relative no-touch-highlight"),
            fluid ? $ezf3v.prefix("h-full") : "",
            cursor,
            className
        ]),
        role: "link",
        tabIndex: 0,
        data: id,
        onMouseLeave: onMouseLeave,
        onMouseOver: handleMouseOver
    };
    if (title !== undefined) tmp$4["aria-label"] = $loT9g.valFromOption(title);
    if (style !== undefined) tmp$4.style = $loT9g.valFromOption(style);
    if (onClickDiv !== undefined) tmp$4.onClick = $loT9g.valFromOption(onClickDiv);
    var tmp$5 = {
        children: /*#__PURE__*/ $g85JO.createElement("div", tmp$4, children$1)
    };
    if (dataTestId !== undefined) tmp$5.dataTestId = $loT9g.valFromOption(dataTestId);
    if (dataCount !== undefined) tmp$5.dataCount = dataCount;
    return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, tmp$5);
}
$9af9e34078600d7a$var$Card.displayName = "Card";
var $9af9e34078600d7a$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($9af9e34078600d7a$var$Card);
 /* make Not a pure module */ 
});

parcelRegister("7E1DP", function(module, exports) {

$parcel$export(module.exports, "CardVideo", function () { return $590d8aca843381df$export$22e6f11022d7896e; });
$parcel$export(module.exports, "make", function () { return $590d8aca843381df$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $diVVk = parcelRequire("diVVk");

var $kQvlq = parcelRequire("kQvlq");

var $1xf0g = parcelRequire("1xf0g");

var $55MCT = parcelRequire("55MCT");

var $IFWJb = parcelRequire("IFWJb");

var $239BR = parcelRequire("239BR");

var $2jMpY = parcelRequire("2jMpY");

var $gCzsf = parcelRequire("gCzsf");

var $1t9ha = parcelRequire("1t9ha");

var $2ZaET = parcelRequire("2ZaET");

var $8E2YL = parcelRequire("8E2YL");
function $590d8aca843381df$var$CategoryCard$CardVideo(Props) {
    var imageUrl = Props.imageUrl;
    var videoUrl = Props.videoUrl;
    var settings = Props.settings;
    var showIndicatorOpt = Props.showIndicator;
    var controlsClassNameOpt = Props.controlsClassName;
    var parentRef = Props.parentRef;
    var alt = Props.alt;
    var fitToContainer = Props.fitToContainer;
    var onImageRendered = Props.onImageRendered;
    var showIndicator = showIndicatorOpt !== undefined ? showIndicatorOpt : false;
    var controlsClassName = controlsClassNameOpt !== undefined ? controlsClassNameOpt : "";
    $IFWJb.use(undefined);
    $kQvlq.useSafeTimeout(undefined, undefined);
    var match = $g85JO.useState(function() {
        return false;
    });
    var setCanRenderVideoCard = match[1];
    var canRenderVideoCard = match[0];
    var onLoad = $g85JO.useCallback(function(param) {
        $iv6Yc._1(setCanRenderVideoCard, function(param) {
            return true;
        });
    }, [
        setCanRenderVideoCard
    ]);
    return /*#__PURE__*/ $g85JO.createElement($239BR.make, {
        render: function render(priority) {
            var tmp;
            if (imageUrl !== undefined) {
                var tmp$1 = {
                    src: imageUrl,
                    fit: fitToContainer ? /* Contain */ 2 : /* Cover */ 1,
                    alt: alt,
                    priority: priority,
                    onLoad: onLoad
                };
                if (onImageRendered !== undefined) tmp$1.onRender = $loT9g.valFromOption(onImageRendered);
                tmp = /*#__PURE__*/ $g85JO.createElement($55MCT.make, tmp$1);
            } else tmp = null;
            var tmp$2 = {
                src: videoUrl,
                controlsClassName: controlsClassName,
                alt: alt,
                showIndicator: showIndicator,
                autoplay: settings.videoAutoPlay,
                loop: settings.videoLoop,
                muted: settings.videoMute,
                controls: settings.videoControls
            };
            if (parentRef !== undefined) tmp$2.parentRef = $loT9g.valFromOption(parentRef);
            return /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, tmp, /*#__PURE__*/ $g85JO.createElement($2ZaET.When.make, {
                condition: imageUrl === undefined || canRenderVideoCard,
                children: /*#__PURE__*/ $g85JO.createElement($1t9ha.make, tmp$2)
            }));
        },
        key: videoUrl
    });
}
$590d8aca843381df$var$CategoryCard$CardVideo.displayName = "CategoryCard.CardVideo";
var $590d8aca843381df$export$22e6f11022d7896e = {
    make: $590d8aca843381df$var$CategoryCard$CardVideo
};
function $590d8aca843381df$var$CategoryCard$Default(Props) {
    var category = Props.category;
    var id = Props.id;
    var shape = Props.shape;
    var fluidOpt = Props.fluid;
    var renderOverlay = Props.renderOverlay;
    var showTitleOpt = Props.showTitle;
    var roundedOpt = Props.rounded;
    var forcedOpenLinkOpt = Props.forcedOpenLink;
    var showDescriptionOpt = Props.showDescription;
    var imageFitToContainer = Props.imageFitToContainer;
    var titleTextSize = Props.titleTextSize;
    var style = Props.style;
    var inspectable = Props.inspectable;
    var onClick = Props.onClick;
    var onImageRendered = Props.onImageRendered;
    var fluid = fluidOpt !== undefined ? fluidOpt : false;
    var showTitle = showTitleOpt !== undefined ? showTitleOpt : true;
    var rounded = roundedOpt !== undefined ? roundedOpt : true;
    var forcedOpenLink = forcedOpenLinkOpt !== undefined ? forcedOpenLinkOpt : false;
    var showDescription = showDescriptionOpt !== undefined ? showDescriptionOpt : true;
    var id$1 = $2whNH.getWithDefault(id, "category-card-" + category.id);
    var nodeId = category.id;
    var isSocialNetworkContent = category.socialNetworkSource !== undefined;
    var dataTestId = isSocialNetworkContent ? "social-network-post" : "category-card-test-id";
    var titleDataTestId = isSocialNetworkContent ? "social-network-post-title" : "category-card-title";
    var match = category.categoryType;
    var tmp;
    tmp = typeof match === "number" || match.TAG !== /* QuickView */ 2 ? "category-card" : "quickview-card";
    var inspectable$1 = $2whNH.getWithDefault(inspectable, tmp);
    var match$1 = $8E2YL.use(undefined);
    var settings = match$1.config.settings;
    var ref = $g85JO.useRef(null);
    var imageFitToContainer$1 = $2whNH.getWithDefault(imageFitToContainer, settings.categoryCardFitToContainer);
    var renderCardVideo = function renderCardVideo(fallbackImageUrl, videoUrl) {
        var tmp = {
            videoUrl: videoUrl,
            settings: settings,
            parentRef: ref,
            alt: category.title,
            fitToContainer: imageFitToContainer$1
        };
        if (fallbackImageUrl !== undefined) tmp.imageUrl = $loT9g.valFromOption(fallbackImageUrl);
        if (onImageRendered !== undefined) tmp.onImageRendered = $loT9g.valFromOption(onImageRendered);
        return /*#__PURE__*/ $g85JO.createElement($590d8aca843381df$var$CategoryCard$CardVideo, tmp);
    };
    var renderAfterTitle = $g85JO.useCallback(function(param) {
        var textAlignmentCn = shape === 0 ? "text-center" : "";
        var description = category.description;
        if (description !== undefined && showDescription && category.showDescription) return $loT9g.some(/*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
            dataTestId: "category-description",
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix($1TRFX.make([
                    "line-clamp-2 text-secondary text-base max-w-lg mt-1",
                    textAlignmentCn
                ]))
            }, $iv6Yc._1($2jMpY.stripHTML, description))
        }));
    }, [
        shape,
        category
    ]);
    var title = showTitle && category.showTitle ? category.title : undefined;
    var imageSize = $1xf0g.getCategoryImageSize(category);
    var handleClick = $g85JO.useMemo(function() {
        var match = category.card;
        var exit = 0;
        switch(match.TAG | 0){
            case /* ImageLinkCard */ 0:
            case /* VideoLinkCard */ 1:
                exit = 2;
                break;
            case /* ImageDisplayCard */ 6:
            case /* VideoDisplayCard */ 7:
                return;
            default:
        }
        if (exit === 2 && $2whNH.isSome($1xf0g.Link.getURL(match._0.link))) return;
        return $2whNH.map(onClick, function(fn, param) {
            $iv6Yc._1(fn, category);
        });
    }, [
        onClick,
        category
    ]);
    var match$2 = category.card;
    var cardLink;
    switch(match$2.TAG | 0){
        case /* ImageLinkCard */ 0:
        case /* VideoLinkCard */ 1:
        case /* MedialessLinkCard */ 5:
            cardLink = match$2._0.link;
            break;
        case /* ImageDisplayCard */ 6:
        case /* VideoDisplayCard */ 7:
            cardLink = undefined;
            break;
        default:
            cardLink = match$2._0.link;
    }
    var match$3 = category.card;
    var preventLinkDefault;
    switch(match$3.TAG | 0){
        case /* ImageLinkCard */ 0:
        case /* VideoLinkCard */ 1:
        case /* MedialessLinkCard */ 5:
            preventLinkDefault = false;
            break;
        case /* ImageDisplayCard */ 6:
        case /* VideoDisplayCard */ 7:
            preventLinkDefault = true;
            break;
        default:
            preventLinkDefault = !forcedOpenLink;
    }
    var match$4 = category.card;
    var cardMedia;
    var exit = 0;
    var imageUrl;
    switch(match$4.TAG | 0){
        case /* ImageLinkCard */ 0:
            imageUrl = match$4._0.imageUrl;
            exit = 1;
            break;
        case /* VideoLinkCard */ 1:
            var match$5 = match$4._0;
            cardMedia = renderCardVideo(match$5.fallbackImageUrl, match$5.videoUrl);
            break;
        case /* ImageCard */ 2:
            imageUrl = match$4._0.imageUrl;
            exit = 1;
            break;
        case /* VideoCard */ 3:
            var match$6 = match$4._0;
            cardMedia = renderCardVideo(match$6.fallbackImageUrl, match$6.videoUrl);
            break;
        case /* MedialessCard */ 4:
        case /* MedialessLinkCard */ 5:
            exit = 2;
            break;
        case /* ImageDisplayCard */ 6:
            imageUrl = match$4._0.imageUrl;
            exit = 1;
            break;
        case /* VideoDisplayCard */ 7:
            var match$7 = match$4._0;
            cardMedia = renderCardVideo(match$7.fallbackImageUrl, match$7.videoUrl);
            break;
    }
    switch(exit){
        case 1:
            cardMedia = /*#__PURE__*/ $g85JO.createElement($239BR.make, {
                render: function render(priority) {
                    var tmp = {
                        src: imageUrl,
                        fit: imageFitToContainer$1 ? /* Contain */ 2 : /* Cover */ 1,
                        alt: category.title,
                        priority: priority
                    };
                    if (onImageRendered !== undefined) tmp.onRender = $loT9g.valFromOption(onImageRendered);
                    return /*#__PURE__*/ $g85JO.createElement($55MCT.make, tmp);
                },
                key: imageUrl
            });
            break;
        case 2:
            cardMedia = /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("absolute inset-0 bg-placeholder")
            });
            break;
    }
    var tmp$1 = {
        shape: shape,
        fluid: fluid,
        id: id$1,
        nodeId: nodeId,
        preventLinkDefault: preventLinkDefault,
        lineClamp: settings.categoryCardTitleLineTruncate,
        openLinkInNewTab: settings.openLinkInNewTab,
        inspectable: inspectable$1,
        rounded: rounded,
        contentBoxStylableClassName: "category-card__content-box",
        titleStylableClassName: "category-card__title",
        imageSize: imageSize,
        fwdRef: ref,
        dataTestId: dataTestId,
        titleDataTestId: titleDataTestId,
        children: cardMedia,
        renderAfterTitle: renderAfterTitle
    };
    if (cardLink !== undefined) tmp$1.link = $loT9g.valFromOption(cardLink);
    if (titleTextSize !== undefined) tmp$1.titleTextSizeDesktop = $loT9g.valFromOption(titleTextSize);
    if (titleTextSize !== undefined) tmp$1.titleTextSizeMobile = $loT9g.valFromOption(titleTextSize);
    if (title !== undefined) tmp$1.title = $loT9g.valFromOption(title);
    if (renderOverlay !== undefined) tmp$1.renderOverlay = $loT9g.valFromOption(renderOverlay);
    if (style !== undefined) tmp$1.style = $loT9g.valFromOption(style);
    if (handleClick !== undefined) tmp$1.onClickDiv = $loT9g.valFromOption(handleClick);
    if (handleClick !== undefined) tmp$1.onClickLink = $loT9g.valFromOption(handleClick);
    return /*#__PURE__*/ $g85JO.createElement($diVVk.make, tmp$1);
}
$590d8aca843381df$var$CategoryCard$Default.displayName = "CategoryCard.Default";
var $590d8aca843381df$export$39bcc3f08a9b5fa4 = {
    make: $590d8aca843381df$var$CategoryCard$Default
};
function $590d8aca843381df$var$CategoryCard(Props) {
    var category = Props.category;
    var id = Props.id;
    var shape = Props.shape;
    var fluidOpt = Props.fluid;
    var renderOverlay = Props.renderOverlay;
    var showVideoIndicatorOpt = Props.showVideoIndicator;
    var showProductCountOpt = Props.showProductCount;
    var showTitleOpt = Props.showTitle;
    var roundedOpt = Props.rounded;
    var forcedOpenLinkOpt = Props.forcedOpenLink;
    var showDescriptionOpt = Props.showDescription;
    var videoControlsClassNameOpt = Props.videoControlsClassName;
    var imageFitToContainer = Props.imageFitToContainer;
    var titleTextSize = Props.titleTextSize;
    var style = Props.style;
    var inspectable = Props.inspectable;
    var onClick = Props.onClick;
    var onImageRendered = Props.onImageRendered;
    var fluid = fluidOpt !== undefined ? fluidOpt : false;
    var showVideoIndicator = showVideoIndicatorOpt !== undefined ? showVideoIndicatorOpt : false;
    var showProductCount = showProductCountOpt !== undefined ? showProductCountOpt : true;
    var showTitle = showTitleOpt !== undefined ? showTitleOpt : true;
    var rounded = roundedOpt !== undefined ? roundedOpt : true;
    var forcedOpenLink = forcedOpenLinkOpt !== undefined ? forcedOpenLinkOpt : false;
    var showDescription = showDescriptionOpt !== undefined ? showDescriptionOpt : true;
    var videoControlsClassName = videoControlsClassNameOpt !== undefined ? videoControlsClassNameOpt : "";
    var tmp = {
        category: category,
        shape: shape,
        fluid: fluid,
        showVideoIndicator: showVideoIndicator,
        showProductCount: showProductCount,
        showTitle: showTitle,
        rounded: rounded,
        forcedOpenLink: forcedOpenLink,
        showDescription: showDescription,
        videoControlsClassName: videoControlsClassName
    };
    if (id !== undefined) tmp.id = id;
    if (renderOverlay !== undefined) tmp.renderOverlay = $loT9g.valFromOption(renderOverlay);
    if (imageFitToContainer !== undefined) tmp.imageFitToContainer = $loT9g.valFromOption(imageFitToContainer);
    if (titleTextSize !== undefined) tmp.titleTextSize = $loT9g.valFromOption(titleTextSize);
    if (style !== undefined) tmp.style = $loT9g.valFromOption(style);
    if (inspectable !== undefined) tmp.inspectable = $loT9g.valFromOption(inspectable);
    if (onClick !== undefined) tmp.onClick = $loT9g.valFromOption(onClick);
    if (onImageRendered !== undefined) tmp.onImageRendered = $loT9g.valFromOption(onImageRendered);
    return /*#__PURE__*/ $g85JO.createElement($590d8aca843381df$var$CategoryCard$Default, tmp);
}
$590d8aca843381df$var$CategoryCard.displayName = "CategoryCard";
var $590d8aca843381df$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($590d8aca843381df$var$CategoryCard);
 /* make Not a pure module */ 
});

parcelRegister("jtD5N", function(module, exports) {

$parcel$export(module.exports, "useDisplayVariantBy", function () { return $e2df0cb09068ecb2$export$e6de69ef03bde6f5; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $2whNH = parcelRequire("2whNH");

var $1xf0g = parcelRequire("1xf0g");

var $hBcYV = parcelRequire("hBcYV");

var $8E2YL = parcelRequire("8E2YL");
function $e2df0cb09068ecb2$export$e6de69ef03bde6f5(param) {
    var match = $8E2YL.use(undefined);
    var config = match.config;
    var match$1 = $hBcYV.useRouter(undefined);
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, config.categories);
    var sortByCategory = $2whNH.map($2whNH.flatMap(activeCategory, $1xf0g.ExternalConnection.getStoreCategoryConnection), function(connection) {
        return connection.sortBy;
    });
    var appliedSort = $2whNH.orElse(match$1.productSort, sortByCategory);
    if (appliedSort === undefined) return config.settings.displayVariantBy;
    switch(appliedSort){
        case /* Default */ 0:
        case /* Featured */ 1:
        case /* BestSellers */ 2:
        case /* Newest */ 3:
            return config.settings.displayVariantBy;
        case /* HighestPrice */ 4:
            return /* HighestPriceVariant */ 1;
        case /* LowestPrice */ 5:
            return /* LowestPriceVariant */ 2;
        case /* HighestDiscount */ 6:
            return /* HighestDiscountVariant */ 3;
    }
}
 /* Category-Showside Not a pure module */ 
});

parcelRegister("czXEM", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $928707842151e7db$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $diVVk = parcelRequire("diVVk");

var $kQxJU = parcelRequire("kQxJU");

var $gCzsf = parcelRequire("gCzsf");

var $hBcYV = parcelRequire("hBcYV");

var $aSJcu = parcelRequire("aSJcu");

var $8bL3C = parcelRequire("8bL3C");
function $928707842151e7db$var$ListPageGrid(Props) {
    var columns = Props.columns;
    var children = Props.children;
    var gapOpt = Props.gap;
    var maxRowsOpt = Props.maxRows;
    var maxWidth = Props.maxWidth;
    var paddingOverride = Props.paddingOverride;
    var verticalPaddingOpt = Props.verticalPadding;
    var firstChild = Props.firstChild;
    var lastChild = Props.lastChild;
    var alwaysShowLastChildOpt = Props.alwaysShowLastChild;
    var className = Props.className;
    var gap = gapOpt !== undefined ? gapOpt : /* Equal */ 0;
    var maxRows = maxRowsOpt !== undefined ? maxRowsOpt : 0;
    var verticalPadding = verticalPaddingOpt !== undefined ? verticalPaddingOpt : false;
    var alwaysShowLastChild = alwaysShowLastChildOpt !== undefined ? alwaysShowLastChildOpt : false;
    var match = $aSJcu.use(undefined);
    var isMobile = match.isMobile;
    var match$1 = $hBcYV.useRouter(undefined);
    var columnNum = $diVVk.Size.getColumns(columns);
    var childrenNum = children.length + ($2whNH.isNone(firstChild) ? 0 : 1) | 0;
    var insertSlots = $8bL3C.use(columnNum, undefined);
    var maxItems = maxRows > 0 ? Math.max(Math.imul(maxRows, columnNum), 1) : 0;
    var maxItems$1 = maxItems > 0 ? maxItems - (isMobile || $2whNH.isNone(lastChild) || maxItems === childrenNum ? 0 : 1) | 0 : maxItems;
    var lastChild$1 = childrenNum > maxItems$1 && maxItems$1 > 0 || alwaysShowLastChild ? lastChild : undefined;
    var gridPadding = match.windowSize.width <= 600 ? "px-4" : "px-8";
    var gridPadding$1 = $2whNH.isNone(paddingOverride) ? gridPadding : "";
    var gapCn;
    if (typeof gap === "number") switch(gap){
        case /* Equal */ 0:
            gapCn = "gap-col-custom";
            break;
        case /* Half */ 1:
            gapCn = "gap-col-custom-half";
            break;
        case /* Double */ 2:
            gapCn = "gap-col-custom-double";
            break;
    }
    else gapCn = "";
    var gapCn$1;
    var tmp = match$1.route;
    gapCn$1 = typeof tmp === "number" || tmp.TAG !== /* ListPage */ 1 ? gapCn : columns !== 3 ? columns >= 8 && !isMobile ? "gap-1" : gapCn : isMobile ? "gap-1" : gapCn;
    var gapInt = typeof gap === "number" ? undefined : $ezf3v.intToPx(gap._0);
    var tmp$1 = {
        gridAutoColumns: "minmax(0, 1fr)"
    };
    var tmp$2 = $2whNH.map(maxWidth, $ezf3v.intToPx);
    if (tmp$2 !== undefined) tmp$1.maxWidth = tmp$2;
    var tmp$3 = $2whNH.map(paddingOverride, $ezf3v.intToPx);
    if (tmp$3 !== undefined) tmp$1.paddingRight = tmp$3;
    var tmp$4 = $2whNH.map(paddingOverride, $ezf3v.intToPx);
    if (tmp$4 !== undefined) tmp$1.paddingLeft = tmp$4;
    if (gapInt !== undefined) tmp$1.gridGap = gapInt;
    var style = tmp$1;
    var tmp$5;
    switch(columns){
        case /* OneColumnGrid */ 0:
            tmp$5 = "grid-cols-1";
            break;
        case /* TwoColumnGrid */ 1:
            tmp$5 = "grid-cols-2";
            break;
        case /* ThreeColumnGrid */ 2:
            tmp$5 = "grid-cols-3";
            break;
        case /* FourColumnGrid */ 3:
            tmp$5 = "grid-cols-4";
            break;
        case /* FiveColumnGrid */ 4:
            tmp$5 = "grid-cols-5";
            break;
        case /* SixColumnGrid */ 5:
            tmp$5 = "grid-cols-6";
            break;
        case /* SevenColumnGrid */ 6:
            tmp$5 = "grid-cols-7";
            break;
        case /* EightColumnGrid */ 7:
            tmp$5 = "grid-cols-8";
            break;
        case /* TwelveColumnGrid */ 8:
            tmp$5 = "grid-cols-12";
            break;
    }
    var className$1 = $1TRFX.make([
        $ezf3v.prefix(gridPadding$1),
        $ezf3v.prefix("grid"),
        $ezf3v.prefix("mx-auto"),
        $ezf3v.prefix("w-full"),
        $ezf3v.prefix(gapCn$1),
        $ezf3v.prefix(tmp$5),
        $2whNH.getWithDefault(className, "")
    ]);
    var childrenWithFirstChild = $g85JO.useMemo(function() {
        return $i7mYY.concat(firstChild !== undefined ? [
            $loT9g.valFromOption(firstChild)
        ] : [], children);
    }, [
        children,
        firstChild
    ]);
    var childrenWithTruncation = $g85JO.useMemo(function() {
        return $i7mYY.keepWithIndex(childrenWithFirstChild, function(child, i) {
            if (maxItems$1 < 1) return true;
            else return i < maxItems$1;
        });
    }, [
        childrenWithFirstChild,
        maxItems$1
    ]);
    var childrenWithSlots = $g85JO.useMemo(function() {
        return $iv6Yc._1(insertSlots, childrenWithTruncation);
    }, [
        childrenWithTruncation,
        columnNum,
        insertSlots
    ]);
    var childrenWithLastChild = $g85JO.useMemo(function() {
        return $i7mYY.concat(childrenWithSlots, lastChild$1 !== undefined ? [
            $loT9g.valFromOption(lastChild$1)
        ] : []);
    }, [
        childrenWithSlots,
        lastChild$1
    ]);
    var renderLastChild = function renderLastChild(param) {
        if (lastChild$1 !== undefined) return /*#__PURE__*/ $g85JO.createElement($kQxJU.make, {
            props: {
                isListItem: true
            },
            children: $loT9g.valFromOption(lastChild$1)
        });
        else return null;
    };
    var isSymmetric = columnNum === 1 || childrenWithSlots.length / columnNum % 1.0 === 0.0;
    if (lastChild$1 !== undefined && isSymmetric) {
        var tmp$6 = {};
        if (gapInt !== undefined) tmp$6.gridGap = gapInt;
        return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
            dataTestId: "list-page-grid",
            children: /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix($1TRFX.make([
                    "grid grid-cols-1",
                    gapCn$1
                ])),
                style: tmp$6
            }, /*#__PURE__*/ $g85JO.createElement("div", {
                className: className$1,
                style: style
            }, childrenWithSlots), /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix($1TRFX.make([
                    gridPadding$1,
                    "m-auto",
                    "w-full"
                ])),
                style: style
            }, renderLastChild(undefined)))
        });
    } else return /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "list-page-grid",
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: $1TRFX.make([
                className$1,
                verticalPadding ? "py-row-custom" : ""
            ]),
            style: style
        }, childrenWithLastChild)
    });
}
$928707842151e7db$var$ListPageGrid.displayName = "ListPageGrid";
var $928707842151e7db$export$dd44f18ab656f3bb = $928707842151e7db$var$ListPageGrid;
 /* react Not a pure module */ 
});
parcelRegister("8bL3C", function(module, exports) {

$parcel$export(module.exports, "use", function () { return $5f63da717232a519$export$1f96ae73734a86cc; });
$parcel$export(module.exports, "make", function () { return $5f63da717232a519$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $d8lRc = parcelRequire("d8lRc");

var $2whNH = parcelRequire("2whNH");

var $ezf3v = parcelRequire("ezf3v");

var $7ybfR = parcelRequire("7ybfR");
var $5f63da717232a519$export$8c6ed5c666ac1360 = {};
function $5f63da717232a519$var$string_of_value(value) {
    if (value) return String(value._0);
    else return "auto";
}
function $5f63da717232a519$var$add(a, b) {
    if (!a) {
        if (b) return b._0;
        else return 99;
    }
    var a$1 = a._0;
    if (b) return a$1 + b._0 | 0;
    else return a$1;
}
function $5f63da717232a519$var$toCSS(coord) {
    return $7ybfR.unsafeAddProp($7ybfR.unsafeAddProp($7ybfR.unsafeAddProp($7ybfR.unsafeAddProp({}, "--smartnav-custom-grid-column-start", $5f63da717232a519$var$string_of_value(coord.x)), "--smartnav-custom-grid-column-end", "span " + $5f63da717232a519$var$string_of_value(coord.w)), "--smartnav-custom-grid-row-start", $5f63da717232a519$var$string_of_value(coord.y)), "--smartnav-custom-grid-row-end", "span " + $5f63da717232a519$var$string_of_value(coord.h));
}
var $5f63da717232a519$export$d6e0f5996cc55599 = {
    string_of_value: $5f63da717232a519$var$string_of_value,
    add: $5f63da717232a519$var$add,
    toCSS: $5f63da717232a519$var$toCSS
};
function $5f63da717232a519$var$defaultPattern(param) {
    var height = param.height;
    var width = param.width;
    var skipRowsNum = height + 2 | 0;
    var adjustedOffset = param.offset > 1 ? param.offset : 1;
    var adjustedIndex = param.index + 1 | 0;
    var x = adjustedIndex % 2 === 0 ? Math.abs((param.columns - width | 0) + 1 | 0) : 0;
    var y = Math.imul(skipRowsNum, adjustedIndex) + (adjustedOffset - skipRowsNum | 0) | 0;
    return {
        x: /* Int */ {
            _0: x
        },
        y: /* Int */ {
            _0: y
        },
        w: /* Int */ {
            _0: width
        },
        h: /* Int */ {
            _0: height
        }
    };
}
var $5f63da717232a519$export$47606a6ae3eaed8e = {
    defaultPattern: $5f63da717232a519$var$defaultPattern
};
var $5f63da717232a519$export$f36c9b20522c59e3 = {
    renderSlots: undefined,
    slotCardWidth: 1,
    slotCardHeight: 1,
    slotCardOffset: 0,
    slotPattern: $5f63da717232a519$var$defaultPattern,
    slotAllowOverflow: false
};
var $5f63da717232a519$export$a078c61943f9dbbe = /*#__PURE__*/ $g85JO.createContext($5f63da717232a519$export$f36c9b20522c59e3);
var $5f63da717232a519$export$9ca6988bf94d5044 = $5f63da717232a519$export$a078c61943f9dbbe.Provider;
function $5f63da717232a519$var$ListPageGridCustomSlots(Props) {
    var renderSlots = Props.renderSlots;
    var slotCardWidthOpt = Props.slotCardWidth;
    var slotCardHeightOpt = Props.slotCardHeight;
    var slotCardOffsetOpt = Props.slotCardOffset;
    var slotPatternOpt = Props.slotPattern;
    var slotAllowOverflowOpt = Props.slotAllowOverflow;
    var children = Props.children;
    var slotCardWidth = slotCardWidthOpt !== undefined ? slotCardWidthOpt : 1;
    var slotCardHeight = slotCardHeightOpt !== undefined ? slotCardHeightOpt : 1;
    var slotCardOffset = slotCardOffsetOpt !== undefined ? slotCardOffsetOpt : 2;
    var slotPattern = slotPatternOpt !== undefined ? slotPatternOpt : $5f63da717232a519$var$defaultPattern;
    var slotAllowOverflow = slotAllowOverflowOpt !== undefined ? slotAllowOverflowOpt : true;
    var value = {
        renderSlots: renderSlots,
        slotCardWidth: slotCardWidth,
        slotCardHeight: slotCardHeight,
        slotCardOffset: slotCardOffset,
        slotPattern: slotPattern,
        slotAllowOverflow: slotAllowOverflow
    };
    return /*#__PURE__*/ $g85JO.createElement($5f63da717232a519$export$9ca6988bf94d5044, {
        value: value,
        children: children
    });
}
$5f63da717232a519$var$ListPageGridCustomSlots.displayName = "ListPageGridCustomSlots";
function $5f63da717232a519$export$1f96ae73734a86cc(columnNum, param) {
    var ctx = $g85JO.useContext($5f63da717232a519$export$a078c61943f9dbbe);
    return $g85JO.useCallback(function(children) {
        var calculateCoordinates = function calculateCoordinates(index, render) {
            var modifiedSlotCardWidth = columnNum < ctx.slotCardWidth ? columnNum : ctx.slotCardWidth;
            var coordinates = $iv6Yc._1(ctx.slotPattern, {
                columns: columnNum,
                index: index,
                width: modifiedSlotCardWidth,
                height: ctx.slotCardHeight,
                offset: ctx.slotCardOffset
            });
            var childrenCount = children.length;
            var media = $2whNH.getWithDefault(ctx.renderSlots, []);
            var mediaSize = Math.imul(ctx.slotCardHeight, modifiedSlotCardWidth);
            var previousMediaCount = Math.imul($i7mYY.keepWithIndex(media, function(item, i) {
                return i < (index - 1 | 0);
            }).length, mediaSize);
            var itemCount = childrenCount + previousMediaCount | 0;
            var remainder = $d8lRc.mod_(itemCount, columnNum);
            var xLast = remainder === 0 && itemCount >= columnNum ? columnNum : remainder;
            var yLast = (Math.round(itemCount / columnNum) | 0) + 1 | 0;
            var canFit = yLast >= $5f63da717232a519$var$add(coordinates.y, coordinates.h) || xLast >= $5f63da717232a519$var$add(coordinates.x, coordinates.w) && yLast >= $5f63da717232a519$var$add(coordinates.y, coordinates.h);
            var coordinates$1 = canFit ? coordinates : {
                x: /* Auto */ 0,
                y: /* Auto */ 0,
                w: /* Auto */ 0,
                h: /* Auto */ 0
            };
            var isMultiColumnGrid = columnNum > 1;
            var isTooWide = modifiedSlotCardWidth >= columnNum;
            var fluid = canFit && isMultiColumnGrid && !isTooWide;
            var shape = canFit && fluid ? /* Custom */ {
                _0: ctx.slotCardWidth,
                _1: ctx.slotCardHeight
            } : canFit ? /* Custom */ {
                _0: 0,
                _1: 0
            } : undefined;
            return {
                render: render,
                style: $5f63da717232a519$var$toCSS(coordinates$1),
                fluid: fluid,
                canFit: canFit,
                shape: shape
            };
        };
        var renderSlot = function renderSlot(index, intermediate) {
            if (intermediate.canFit || ctx.slotAllowOverflow) return /*#__PURE__*/ $g85JO.createElement("div", {
                key: "slot-card-" + String(index),
                className: $ezf3v.prefix("custom-grid relative"),
                style: intermediate.style
            }, $iv6Yc._2(intermediate.render, intermediate.fluid, intermediate.shape));
            else return null;
        };
        return $i7mYY.concat(children, $i7mYY.mapWithIndex($i7mYY.mapWithIndex($2whNH.getWithDefault(ctx.renderSlots, []), calculateCoordinates), renderSlot));
    }, [
        ctx
    ]);
}
var $5f63da717232a519$export$dd44f18ab656f3bb = $5f63da717232a519$var$ListPageGridCustomSlots;
 /* context Not a pure module */ 
});


parcelRegister("khAUl", function(module, exports) {

$parcel$export(module.exports, "getSmartCard", function () { return $ec4206456387c3ac$export$4c73346aa5867b71; });
$parcel$export(module.exports, "use", function () { return $ec4206456387c3ac$export$1f96ae73734a86cc; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $1xf0g = parcelRequire("1xf0g");

var $loo94 = parcelRequire("loo94");

var $IFWJb = parcelRequire("IFWJb");

var $2jMpY = parcelRequire("2jMpY");

var $7E1DP = parcelRequire("7E1DP");

var $aSJcu = parcelRequire("aSJcu");

var $9pMGg = parcelRequire("9pMGg");

var $8E2YL = parcelRequire("8E2YL");
function $ec4206456387c3ac$export$4c73346aa5867b71(title, visibleInMenuBarOpt, firstCardOpt, category) {
    var visibleInMenuBar = visibleInMenuBarOpt !== undefined ? visibleInMenuBarOpt : false;
    var firstCard = firstCardOpt !== undefined ? firstCardOpt : false;
    var match = $1xf0g.ExternalConnection.getStoreCategoryConnection(category);
    if (match === undefined) return;
    if ($1xf0g.getChildren(category).length === 0) return;
    var newrecord = $7bjme.obj_dup(category);
    return newrecord.categoryType = {
        TAG: /* Standard */ 1,
        _0: {
            firstCard: firstCard ? $1xf0g.getFirstCard(category) : undefined,
            externalConnection: $1xf0g.ExternalConnection.getConnection(category),
            children: [],
            loadMoreChildren: undefined,
            totalChildren: 0,
            link: undefined,
            products: $1xf0g.getProducts(category),
            taggedMedia: $1xf0g.TaggedMedia.get(category),
            imageHotspots: undefined,
            imageWidth: undefined,
            imageHeight: undefined
        }
    }, newrecord.card = $2whNH.getWithDefault($1xf0g.getFirstCard(category), category.card), newrecord.visibleInMenuBar = visibleInMenuBar, newrecord.description = undefined, newrecord.title = $2whNH.getWithDefault(title, "All"), newrecord.id = category.id, newrecord;
}
function $ec4206456387c3ac$export$1f96ae73734a86cc(contentType, activeCategory, layout, enableSmartCardOpt, enableFirstCardOpt, enableLastCardOpt, forcedOpenLink, category) {
    var enableSmartCard = enableSmartCardOpt !== undefined ? enableSmartCardOpt : false;
    var enableFirstCard = enableFirstCardOpt !== undefined ? enableFirstCardOpt : false;
    var enableLastCard = enableLastCardOpt !== undefined ? enableLastCardOpt : false;
    var match = $aSJcu.use(undefined);
    var match$1 = $8E2YL.use(undefined).config;
    var category$1 = $2whNH.getWithDefault($1xf0g.getCategoryById(match$1.categories, category.id), category);
    var activeCategoryId = $2whNH.map(activeCategory, function(c) {
        return c.id;
    });
    var storeConnection = $1xf0g.ExternalConnection.getStoreCategoryConnection(category$1);
    var hasSubCats = $1xf0g.hasSubCategories(category$1);
    var isConnected = $2whNH.isSome(storeConnection);
    var isConnectedWithSubCats = isConnected && hasSubCats;
    var canRenderSmartCard = !match.isMobile && enableSmartCard && enableFirstCard;
    var canRenderFirstCard = ($7bjme.notequal(category$1.id, activeCategoryId) || contentType === /* Category */ 0) && enableFirstCard;
    var match$2 = $IFWJb.use(undefined);
    var onMainImageRendered = match$2.onMainImageRendered;
    var match$3 = $9pMGg.use(undefined);
    var onSmartCardClick = match$3.onSmartCardClick;
    var onCategoryClick = match$3.onCategoryClick;
    var trackEvent = match$3.trackEvent;
    var forcedOpenLink$1 = $2whNH.getWithDefault(forcedOpenLink, /* ForceNoCards */ 3);
    var forceOpenLinkFirstCard = forcedOpenLink$1 === /* ForceAllCards */ 0 || forcedOpenLink$1 === /* ForceFirstAndLastCards */ 1;
    var forceOpenLinkLastCard = forcedOpenLink$1 === /* ForceAllCards */ 0 || forcedOpenLink$1 === /* ForceFirstAndLastCards */ 1 || forcedOpenLink$1 === /* ForceLastCards */ 2;
    var onImageRendered = $g85JO.useCallback(function(param) {
        $iv6Yc._1(onMainImageRendered, undefined);
    }, []);
    var cardShape = contentType ? $1xf0g.CategoryCard.getCardShape(match$1.settings.productCardShape, [
        /* Square */ 1,
        /* Portrait */ 3,
        /* Landscape */ 2
    ], category$1.card) : $1xf0g.CategoryCard.getCardShape(undefined, undefined, category$1.card);
    var smartCard = $g85JO.useMemo(function() {
        return $ec4206456387c3ac$export$4c73346aa5867b71(undefined, undefined, undefined, category$1);
    }, [
        category$1.id,
        match$1.lastModifiedAt
    ]);
    var smartCard$1;
    if (smartCard !== undefined && canRenderSmartCard) {
        var newrecord = $7bjme.obj_dup(category$1);
        smartCard$1 = $loT9g.some(/*#__PURE__*/ $g85JO.createElement($7E1DP.make, {
            category: (newrecord.card = $2whNH.getWithDefault($1xf0g.getFirstCard(category$1), category$1.card), newrecord.title = $2jMpY.concatWithoutRepeat("All", category$1.title), newrecord),
            id: "" + category$1.id + "-smart-card",
            shape: cardShape,
            forcedOpenLink: forceOpenLinkFirstCard,
            inspectable: "first-card",
            onClick: onSmartCardClick,
            onImageRendered: onImageRendered,
            key: "" + category$1.id + "-smart-card"
        }));
    } else smartCard$1 = undefined;
    var firstCard = $2whNH.map($2whNH.keep($1xf0g.getFirstCard(category$1), function(param) {
        return canRenderFirstCard;
    }), function(card) {
        var newrecord = $7bjme.obj_dup(category$1);
        return /*#__PURE__*/ $g85JO.createElement($7E1DP.make, {
            category: (newrecord.card = card, newrecord.showTitle = false, newrecord.description = undefined, newrecord),
            id: "" + category$1.id + "-first-card",
            shape: cardShape,
            showProductCount: false,
            forcedOpenLink: forceOpenLinkFirstCard,
            inspectable: "first-card",
            onClick: isConnectedWithSubCats ? onSmartCardClick : onCategoryClick,
            onImageRendered: onImageRendered,
            key: "" + category$1.id + "-first-card"
        });
    });
    var firstCard$1 = smartCard$1 !== undefined ? smartCard$1 : firstCard !== undefined ? firstCard : undefined;
    var match$4 = $1xf0g.Link.getCardFallbackLink(category$1);
    var lastCardLink = match$4 !== undefined && match$4.TAG === /* URL */ 0 && (!isConnected || forceOpenLinkLastCard) ? match$4._0 : undefined;
    var onEndCardClick = function onEndCardClick(param) {
        if (lastCardLink !== undefined) return $iv6Yc.app(trackEvent, [
            "slider:see all link",
            true,
            category$1,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
        else if (isConnectedWithSubCats) return $iv6Yc._1(onSmartCardClick, category$1);
        else return $iv6Yc._1(onCategoryClick, category$1);
    };
    var lastCard;
    if (layout.TAG === /* SliderLayout */ 0 || !(enableLastCard && ($2whNH.isSome(lastCardLink) || !forceOpenLinkLastCard))) lastCard = undefined;
    else {
        var tmp = {
            title: category$1.title,
            shape: cardShape,
            onClick: onEndCardClick,
            key: "" + category$1.id + "-last-card"
        };
        if (lastCardLink !== undefined) tmp.href = $loT9g.valFromOption(lastCardLink);
        lastCard = $loT9g.some(/*#__PURE__*/ $g85JO.createElement($loo94.make, tmp));
    }
    return [
        firstCard$1,
        lastCard
    ];
}
 /* react Not a pure module */ 
});
parcelRegister("loo94", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $f92e91a33e516970$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $tUpyX = parcelRequire("tUpyX");

var $5PS1O = parcelRequire("5PS1O");

var $2jMpY = parcelRequire("2jMpY");

var $5av24 = parcelRequire("5av24");

var $aSJcu = parcelRequire("aSJcu");

var $8E2YL = parcelRequire("8E2YL");
function $f92e91a33e516970$var$LastCard(Props) {
    var href = Props.href;
    var title = Props.title;
    var linkLabel = Props.linkLabel;
    var shape = Props.shape;
    var icon = Props.icon;
    var isListItemOpt = Props.isListItem;
    var onClick = Props.onClick;
    var isListItem = isListItemOpt !== undefined ? isListItemOpt : false;
    var match = $8E2YL.use(undefined).config;
    var settings = match.settings;
    $aSJcu.use(undefined);
    var linkLabel$1 = $2whNH.getWithDefault(linkLabel, settings.openLinkLabel);
    var openLinkInNewTab = settings.openLinkInNewTab;
    var aspectRatioCn;
    if (typeof shape === "number") switch(shape){
        case /* Circle */ 0:
        case /* Square */ 1:
            aspectRatioCn = "aspect-ratio-square";
            break;
        case /* Landscape */ 2:
            aspectRatioCn = "aspect-ratio-4/3";
            break;
        case /* Portrait */ 3:
            aspectRatioCn = "aspect-ratio-2/3";
            break;
        case /* Panorama */ 4:
            aspectRatioCn = "aspect-ratio-21/9";
            break;
        case /* Wide */ 5:
            aspectRatioCn = "aspect-ratio-16/9";
            break;
        case /* Tall */ 6:
            aspectRatioCn = "aspect-ratio-9/16";
            break;
    }
    else aspectRatioCn = "";
    var aspectRatioStyle = typeof shape === "number" ? undefined : {
        paddingBottom: $ezf3v.floatToPercentage(shape._1 / shape._0 * 100.0)
    };
    var aspectRatioCn$1 = isListItem ? "" : aspectRatioCn;
    var aspectRatioStyle$1 = isListItem ? undefined : aspectRatioStyle;
    var flexDirCn = isListItem ? "flex-row-reverse space-x-reverse" : "flex-col";
    var heightCn = isListItem ? "h-14" : "h-0";
    var positionCn = isListItem ? "relative" : "absolute";
    var spaceBetweenCn = isListItem ? "space-x-2" : "space-y-4";
    var textPaddingCn = isListItem ? "" : "px-6";
    var textAlignmentCn = isListItem ? "text-left" : "text-center";
    var paddingCn = isListItem ? "px-4" : "";
    var arrow = /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            isListItem ? "w-8 h-8" : "w-12 h-12",
            "block rounded-full flex items-center justify-center overflow-hidden relative flex-shrink-0"
        ]))
    }, isListItem ? null : /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix("absolute inset-0 opacity-10 group-2-hover:opacity-25 bg-tertiary")
    }), $2whNH.getWithDefault(icon, /*#__PURE__*/ $g85JO.createElement($5PS1O.make, {
        className: $ezf3v.prefix($1TRFX.make([
            isListItem ? "h-4" : "h-5 relative left-px",
            "text-primary"
        ])),
        strokeWidth: "4"
    })));
    var tmp = {
        children: null,
        unstyled: true,
        className: $ezf3v.prefix($1TRFX.make([
            "flex cursor-pointer justify-center no-underline relative overflow-hidden transform-gpu no-touch-highlight group-2",
            heightCn,
            aspectRatioCn$1,
            "rounded-custom",
            paddingCn
        ])),
        openLinkInNewTab: openLinkInNewTab
    };
    if (href !== undefined) tmp.href = $loT9g.valFromOption(href);
    if (aspectRatioStyle$1 !== undefined) tmp.style = $loT9g.valFromOption(aspectRatioStyle$1);
    if (onClick !== undefined) tmp.onClick = $loT9g.valFromOption(onClick);
    return /*#__PURE__*/ $g85JO.createElement("div", undefined, /*#__PURE__*/ $g85JO.createElement($tUpyX.make, tmp, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "absolute inset-0 opacity-10 group-2-hover:opacity-25",
            "bg-tertiary"
        ]))
    }), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "inset-0 flex items-center justify-center text-primary rounded-inherit font-semibold transform-gpu text-lg",
            positionCn,
            flexDirCn,
            spaceBetweenCn
        ]))
    }, arrow, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            textAlignmentCn,
            textPaddingCn
        ]))
    }, /*#__PURE__*/ $g85JO.createElement($5av24.make, {
        lines: 2,
        children: $2jMpY.concatWithoutRepeat(linkLabel$1, title)
    })))));
}
$f92e91a33e516970$var$LastCard.displayName = "LastCard";
var $f92e91a33e516970$export$dd44f18ab656f3bb = $f92e91a33e516970$var$LastCard;
 /* react Not a pure module */ 
});
parcelRegister("5PS1O", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $43fba00e355f93ca$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");
function $43fba00e355f93ca$var$IconNext(Props) {
    var className = Props.className;
    var strokeWidthOpt = Props.strokeWidth;
    var strokeWidth = strokeWidthOpt !== undefined ? strokeWidthOpt : "3.135";
    var tmp = {
        height: "28",
        width: "17",
        viewBox: "0 0 17 28",
        xmlns: "http://www.w3.org/2000/svg"
    };
    if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M 2.024 26.025 L 14.563 14.27 L 2.024 2.514",
        fill: "transparent",
        stroke: "currentColor",
        strokeLinecap: "round",
        strokeMiterlimit: "10",
        strokeWidth: strokeWidth
    }));
}
$43fba00e355f93ca$var$IconNext.displayName = "IconNext";
var $43fba00e355f93ca$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($43fba00e355f93ca$var$IconNext);
 /* make Not a pure module */ 
});



parcelRegister("hP9EI", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $cf9eb0886ec03f81$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $81N94 = parcelRequire("81N94");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $c6E1z = parcelRequire("c6E1z");

var $16qP0 = parcelRequire("16qP0");

var $gmnIq = parcelRequire("gmnIq");

var $1xf0g = parcelRequire("1xf0g");

var $i3Bxr = parcelRequire("i3Bxr");

var $IFWJb = parcelRequire("IFWJb");

var $deuug = parcelRequire("deuug");

var $7E1DP = parcelRequire("7E1DP");

var $czXEM = parcelRequire("czXEM");

var $kMqPq = parcelRequire("kMqPq");

var $5ZuQ4 = parcelRequire("5ZuQ4");

var $lcQc5 = parcelRequire("lcQc5");

var $hBcYV = parcelRequire("hBcYV");

var $gamGp = parcelRequire("gamGp");

var $aSJcu = parcelRequire("aSJcu");

var $9pMGg = parcelRequire("9pMGg");

var $khAUl = parcelRequire("khAUl");

var $8E2YL = parcelRequire("8E2YL");

var $b8WNX = parcelRequire("b8WNX");

var $HqFR6 = parcelRequire("HqFR6");
function $cf9eb0886ec03f81$export$f80c710216eae131(shape, viewport, category) {
    var match = $16qP0.use(undefined);
    var match$1 = category.categoryType;
    var match$2;
    if (typeof match$1 === "number") match$2 = [
        undefined,
        0
    ];
    else switch(match$1.TAG | 0){
        case /* Standard */ 1:
            var match$3 = match$1._0;
            match$2 = [
                match$3.loadMoreChildren,
                match$3.totalChildren
            ];
            break;
        case /* QuickView */ 2:
            var match$4 = match$1._0;
            match$2 = [
                match$4.loadMoreChildren,
                match$4.totalChildren
            ];
            break;
        case /* ConfigEmbed */ 4:
            var match$5 = match$1._0;
            match$2 = [
                match$5.loadMoreChildren,
                match$5.totalChildren
            ];
            break;
        default:
            match$2 = [
                undefined,
                0
            ];
    }
    var match$6 = $c6E1z.usePaginateCategories(undefined, match.smartnavApiHost, $kMqPq.nodeLimit, match$2[0], undefined);
    var match$7 = match$6.swr;
    var error = match$7.error;
    var setNumPages = match$7.setSize;
    var numPages = match$7.size;
    var data = match$7.data;
    var totalPlaceholderCount = match$2[1] - Math.imul($kMqPq.nodeLimit, numPages + 1 | 0) | 0;
    var renderedPlaceholderCount = $81N94.int_min(totalPlaceholderCount > 0 ? totalPlaceholderCount : 0, $kMqPq.nodeLimit);
    var renderedPlaceholderCount$1 = error === undefined || renderedPlaceholderCount < 1 ? renderedPlaceholderCount : 1;
    var numLoadedPages = $2whNH.mapWithDefault(data, 1, function(data) {
        return data.length;
    });
    var getPlaceholders = function getPlaceholders(param) {
        return $i7mYY.makeBy(renderedPlaceholderCount$1, function(i) {
            if (i !== 0) return /*#__PURE__*/ $g85JO.createElement($gamGp.make, {
                showTitle: false,
                shape: shape,
                kind: /* Category */ 1,
                dataTestId: "placeholder-card-testid",
                contentBoxStylableClassName: "category-card__content-box",
                titleStylableClassName: "category-card__title",
                key: "placeholder-" + String(i) + ""
            });
            var tmp = {
                numLoadedPages: numLoadedPages,
                numPages: numPages,
                setNumPages: setNumPages,
                viewport: viewport,
                renderChildren: function renderChildren(el) {
                    return /*#__PURE__*/ $g85JO.createElement($gamGp.make, {
                        showTitle: false,
                        shape: shape,
                        kind: /* Category */ 1,
                        dataTestId: "proximity-card-testid",
                        contentBoxStylableClassName: "category-card__content-box",
                        titleStylableClassName: "category-card__title",
                        children: el
                    });
                },
                key: "proximity-sensor"
            };
            if (error !== undefined) tmp.error = error;
            return /*#__PURE__*/ $g85JO.createElement($HqFR6.make, tmp);
        });
    };
    var renderCards = function renderCards(renderFn) {
        return $i7mYY.concat($i7mYY.mapWithIndex($i7mYY.concatMany($i7mYY.map($2whNH.getWithDefault(data, []), function(page) {
            return page.categories;
        })), renderFn), getPlaceholders(undefined));
    };
    return {
        renderCards: renderCards,
        data: data
    };
}
function $cf9eb0886ec03f81$var$CategoryContent(Props) {
    var category = Props.category;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var layout = Props.layout;
    var enableSmartCardOpt = Props.enableSmartCard;
    var enableFirstCardOpt = Props.enableFirstCard;
    var enableLastCardOpt = Props.enableLastCard;
    var shouldCenterSlidesOpt = Props.shouldCenterSlides;
    var enableScrollbarOpt = Props.enableScrollbar;
    var priorityOpt = Props.priority;
    var index = Props.index;
    var isPaddingEnabledOpt = Props.isPaddingEnabled;
    var verticalPaddingOpt = Props.verticalPadding;
    var subCategories = Props.subCategories;
    var forcedSize = Props.forcedSize;
    var forcedShape = Props.forcedShape;
    var forcedRounded = Props.forcedRounded;
    var forcedHideTitleOpt = Props.forcedHideTitle;
    var forcedHideDescriptionOpt = Props.forcedHideDescription;
    var forcedOpenLink = Props.forcedOpenLink;
    var className = Props.className;
    var onOverlayProductClick = Props.onOverlayProductClick;
    var onCategoryClick = Props.onCategoryClick;
    var onQuickViewClick = Props.onQuickViewClick;
    var onProductClick = Props.onProductClick;
    var enableSmartCard = enableSmartCardOpt !== undefined ? enableSmartCardOpt : false;
    var enableFirstCard = enableFirstCardOpt !== undefined ? enableFirstCardOpt : true;
    var enableLastCard = enableLastCardOpt !== undefined ? enableLastCardOpt : true;
    var shouldCenterSlides = shouldCenterSlidesOpt !== undefined ? shouldCenterSlidesOpt : false;
    var enableScrollbar = enableScrollbarOpt !== undefined ? enableScrollbarOpt : true;
    var priority = priorityOpt !== undefined ? priorityOpt : 0;
    var isPaddingEnabled = isPaddingEnabledOpt !== undefined ? isPaddingEnabledOpt : true;
    var verticalPadding = verticalPaddingOpt !== undefined ? verticalPaddingOpt : false;
    var forcedHideTitle = forcedHideTitleOpt !== undefined ? forcedHideTitleOpt : false;
    var forcedHideDescription = forcedHideDescriptionOpt !== undefined ? forcedHideDescriptionOpt : false;
    var match = $8E2YL.use(undefined).config;
    var activeCategory = $hBcYV.useActiveCategory(undefined, undefined, match.categories);
    var subCategories$1 = $2whNH.getWithDefault(subCategories, $1xf0g.getChildren(category));
    var match$1 = $aSJcu.use(undefined);
    var match$2 = match$1.windowSize;
    var windowHeight = match$2.height;
    var isMobile = match$1.isMobile;
    var match$3 = $hBcYV.useRouter(undefined);
    var previewMode = match$3.previewMode;
    var route = match$3.route;
    $9pMGg.use(undefined);
    var match$4 = $IFWJb.use(undefined);
    var onMainImageRendered = match$4.onMainImageRendered;
    var contentRef = $g85JO.useRef(null);
    $gmnIq.useSize(contentRef);
    var onImageRendered = $g85JO.useCallback(function(param) {
        $iv6Yc._1(onMainImageRendered, undefined);
    }, []);
    var cardSize = $2whNH.getWithDefault(forcedSize, $1xf0g.CategoryCard.getCardSize(/* Md */ 4, category.card));
    var cardShape = $2whNH.getWithDefault(forcedShape, $1xf0g.CategoryCard.getCardShape(undefined, undefined, category.card));
    var match$5 = $khAUl.use(/* Category */ 0, activeCategory, layout, enableSmartCard, enableFirstCard, enableLastCard, $2whNH.map(forcedOpenLink, function(forcedOpenLink) {
        return $iv6Yc._1(forcedOpenLink, category);
    }), category);
    var lastCard = match$5[1];
    var firstCard = match$5[0];
    var onOverlayProductClick$1 = $2whNH.getWithDefault(onOverlayProductClick, function(param, param$1, param$2, param$3) {});
    var onProductClickFromOverlayClick = $g85JO.useCallback(function(param) {
        return function(param, product, variant) {
            return $iv6Yc._2(onProductClick, product, variant);
        };
    }, [
        $hBcYV.toString(route)
    ]);
    var onCategoryClick$1 = $g85JO.useMemo(function() {
        return onCategoryClick;
    }, [
        $hBcYV.toString(route)
    ]);
    var onQuickViewClick$1 = $g85JO.useMemo(function() {
        return onQuickViewClick;
    }, [
        $hBcYV.toString(route)
    ]);
    var rootMarginX = Math.imul(match$2.width, isMobile ? 3 : 2);
    var slidesPerView = Math.ceil($1xf0g.CardSize.getSlidesPerView(cardSize)) | 0;
    var slidesPerView$1 = priority !== 1 ? priority !== 2 ? undefined : slidesPerView : slidesPerView << 1;
    var sliderRef = $g85JO.useRef(null);
    var match$6 = $g85JO.useState(function() {
        return false;
    });
    var setSliderInitialized = match$6[1];
    var handleSliderInit = $g85JO.useCallback(function(swiperController) {
        sliderRef.current = swiperController.el;
        $iv6Yc._1(setSliderInitialized, function(param) {
            return true;
        });
    }, [
        category
    ]);
    var getViewport = function getViewport(layout) {
        var match = sliderRef.current;
        if (layout.TAG === /* SliderLayout */ 0 && !(match == null)) return sliderRef;
        else return scrollableContainerRef;
    };
    var isQuickViewStoriesEnabled = $1xf0g.isQuickViewStoriesEnabled(category);
    var isAnySiblingQuickView = $i7mYY.some(subCategories$1, function(subCat) {
        var match = subCat.categoryType;
        if (typeof match === "number") return false;
        if (match.TAG !== /* QuickView */ 2) return false;
        var match$1 = match._0;
        if (match$1.products.length !== 0) return true;
        else if ($i7mYY.keep(match$1.children, $1xf0g.isQuickView).length !== 0) return $1xf0g.isQuickView(category);
        else return false;
    });
    var isSocialNetworkPost = $2whNH.isSome(category.socialNetworkSource);
    var renderCard = function renderCard(cardIndex, subCat) {
        var fallbackElement = /*#__PURE__*/ $g85JO.createElement($gamGp.make, {
            title: subCat.title,
            showTitle: subCat.showTitle && !forcedHideTitle,
            shape: cardShape,
            kind: /* Category */ 1,
            contentBoxStylableClassName: "category-card__content-box",
            titleStylableClassName: "category-card__title",
            key: subCat.id
        });
        var match = subCat.categoryType;
        var categoryCard;
        var exit = 0;
        if (typeof match === "number") exit = 1;
        else switch(match.TAG | 0){
            case /* Standard */ 1:
                if ($2whNH.isSome(match._0.imageHotspots)) {
                    var tmp = {
                        category: subCat,
                        shape: cardShape,
                        showTitle: !forcedHideTitle,
                        showDescription: !forcedHideDescription,
                        enableViewProductButton: false,
                        onClick: function onClick(param, category) {
                            $iv6Yc._1(onCategoryClick$1, category);
                        },
                        onOverlayProductClick: onProductClickFromOverlayClick,
                        onImageRendered: onImageRendered,
                        key: subCat.id
                    };
                    if (forcedRounded !== undefined) tmp.rounded = $loT9g.valFromOption(forcedRounded);
                    categoryCard = /*#__PURE__*/ $g85JO.createElement($5ZuQ4.make, tmp);
                } else exit = 1;
                break;
            case /* QuickView */ 2:
                if (isAnySiblingQuickView || isQuickViewStoriesEnabled || isSocialNetworkPost) {
                    $iv6Yc._1($b8WNX.preload, undefined);
                    var tmp$1 = {
                        category: subCat,
                        parentCategory: category,
                        shape: cardShape,
                        showTitle: !forcedHideTitle,
                        showDescription: !forcedHideDescription,
                        showTaggedProducts: !isMobile,
                        onClick: onQuickViewClick$1,
                        onOverlayProductClick: onOverlayProductClick$1,
                        onImageRendered: onImageRendered,
                        key: subCat.id
                    };
                    if (forcedRounded !== undefined) tmp$1.rounded = $loT9g.valFromOption(forcedRounded);
                    categoryCard = /*#__PURE__*/ $g85JO.createElement($5ZuQ4.make, tmp$1);
                } else exit = 1;
                break;
            default:
                exit = 1;
        }
        if (exit === 1) {
            var tmp$2 = {
                category: subCat,
                shape: cardShape,
                showTitle: !forcedHideTitle,
                forcedOpenLink: $2whNH.mapWithDefault(forcedOpenLink, false, function(fn) {
                    return $iv6Yc._1(fn, subCat) === /* ForceAllCards */ 0;
                }),
                showDescription: !forcedHideDescription,
                onClick: onCategoryClick$1,
                onImageRendered: onImageRendered,
                key: subCat.id
            };
            if (forcedRounded !== undefined) tmp$2.rounded = $loT9g.valFromOption(forcedRounded);
            categoryCard = /*#__PURE__*/ $g85JO.createElement($7E1DP.make, tmp$2);
        }
        var visibleByDefault = index < 3 && cardIndex < 3 || $7bjme.equal(previewMode, /* PreviewHead */ 0);
        if (visibleByDefault) return categoryCard;
        else return /*#__PURE__*/ $g85JO.createElement($deuug.make, {
            trackRenderedElementsWithId: subCat.id,
            thresholds: [
                0.1
            ],
            rootMargin: "" + String(windowHeight) + "px " + String(rootMarginX) + "px",
            viewport: getViewport(layout),
            children: categoryCard,
            fallbackElement: fallbackElement,
            key: subCat.id
        });
    };
    var match$7 = $cf9eb0886ec03f81$export$f80c710216eae131(cardShape, getViewport(layout), category);
    var renderPaginatedCards = match$7.renderCards;
    var cards = $g85JO.useMemo(function() {
        var cards = $i7mYY.concat($i7mYY.mapWithIndex(subCategories$1, renderCard), $iv6Yc._1(renderPaginatedCards, renderCard));
        if (slidesPerView$1 !== undefined) return $i7mYY.slice(cards, 0, slidesPerView$1);
        else return cards;
    }, [
        match.lastModifiedAt,
        $i7mYY.joinWith(subCategories$1, "|", function(cat) {
            return cat.id;
        }),
        cardShape,
        onCategoryClick$1,
        onOverlayProductClick$1,
        onImageRendered,
        onProductClickFromOverlayClick,
        slidesPerView$1,
        rootMarginX,
        windowHeight,
        match$6[0],
        $i3Bxr.layoutToString(layout),
        match$7.data
    ]);
    if (layout.TAG === /* SliderLayout */ 0) {
        if (cards.length === 0) return null;
        var match$8 = layout._0;
        var tmp = {
            id: category.id,
            rows: match$8.rows,
            children: cards,
            shouldCenter: shouldCenterSlides,
            slidesPerView: match$8.slidesPerView,
            gap: match$8.gap,
            effect: match$8.effect,
            nav: match$8.nav,
            transition: match$8.transition,
            transitionSpeed: match$8.transitionSpeed,
            autoplay: match$8.autoplay,
            autoplayDelay: match$8.autoplayDelay,
            loop: match$8.loop,
            duplicateSlidesForLoopingAutoplay: true,
            verticalPadding: verticalPadding,
            enableScrollbar: enableScrollbar,
            onInit: handleSliderInit
        };
        if (match$8.padding !== undefined) tmp.padding = match$8.padding;
        if (match$8.maxWidth !== undefined) tmp.maxWidth = match$8.maxWidth;
        if (firstCard !== undefined) tmp.firstSlide = $loT9g.valFromOption(firstCard);
        if (lastCard !== undefined) tmp.lastSlide = $loT9g.valFromOption(lastCard);
        if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
        return /*#__PURE__*/ $g85JO.createElement($lcQc5.make, tmp);
    }
    if (cards.length === 0) return null;
    var match$9 = layout._0;
    var tmp$1 = {
        columns: match$9.columns,
        children: cards,
        gap: match$9.gap,
        verticalPadding: verticalPadding
    };
    if (match$9.maxRows !== undefined) tmp$1.maxRows = match$9.maxRows;
    if (match$9.maxWidth !== undefined) tmp$1.maxWidth = match$9.maxWidth;
    var tmp$2 = isPaddingEnabled ? match$9.padding : 0;
    if (tmp$2 !== undefined) tmp$1.paddingOverride = tmp$2;
    if (firstCard !== undefined) tmp$1.firstChild = $loT9g.valFromOption(firstCard);
    if (lastCard !== undefined) tmp$1.lastChild = $loT9g.valFromOption(lastCard);
    if (className !== undefined) tmp$1.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement($czXEM.make, tmp$1);
}
$cf9eb0886ec03f81$var$CategoryContent.displayName = "CategoryContent";
var $cf9eb0886ec03f81$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($cf9eb0886ec03f81$var$CategoryContent);
 /* make Not a pure module */ 
});
parcelRegister("gmnIq", function(module, exports) {

$parcel$export(module.exports, "useSize", function () { return $be9118da1ad64c35$export$1ab7ae714698c4b8; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $gGTAE = parcelRequire("gGTAE");
function $be9118da1ad64c35$export$1ab7ae714698c4b8(target) {
    var match = $g85JO.useState(function() {
        return {
            width: 0.0,
            height: 0.0,
            top: 0.0
        };
    });
    var setSize = match[1];
    (0, $gGTAE.default)(target, function(entry) {
        $iv6Yc._1(setSize, function(param) {
            return entry.contentRect;
        });
    });
    return match[0];
}
 /* react Not a pure module */ 
});

parcelRegister("deuug", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $9a243b44307d8f73$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $d3YYW = parcelRequire("d3YYW");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $5bEXW = parcelRequire("5bEXW");

var $iJp5F = parcelRequire("iJp5F");
var $9a243b44307d8f73$var$lazyRenderRenderedIds = {};
function $9a243b44307d8f73$var$LazyRender(Props) {
    var trackRenderedElementsWithId = Props.trackRenderedElementsWithId;
    var thresholdsOpt = Props.thresholds;
    var rootMarginOpt = Props.rootMargin;
    var viewport = Props.viewport;
    var children = Props.children;
    var fallbackElementOpt = Props.fallbackElement;
    var thresholds = thresholdsOpt !== undefined ? thresholdsOpt : [
        0.0
    ];
    var rootMargin = rootMarginOpt !== undefined ? rootMarginOpt : "0px";
    var fallbackElement = fallbackElementOpt !== undefined ? $loT9g.valFromOption(fallbackElementOpt) : null;
    var hasEverBeenVisible = trackRenderedElementsWithId !== undefined && trackRenderedElementsWithId !== "" ? $2whNH.getWithDefault($d3YYW.get($9a243b44307d8f73$var$lazyRenderRenderedIds, trackRenderedElementsWithId), false) : false;
    var match = $g85JO.useState(function() {
        return hasEverBeenVisible;
    });
    var setIsVisible = match[1];
    var isVisible = match[0];
    var ref = $g85JO.useRef(null);
    var match$1 = $g85JO.useState(function() {
        return false;
    });
    var setRefInitialized = match$1[1];
    var match$2 = $iJp5F.use(ref, viewport, hasEverBeenVisible, thresholds, rootMargin, undefined, undefined, undefined);
    var isIntersecting = match$2.isIntersecting;
    var setRef = function setRef(element) {
        ref.current = element;
        $iv6Yc._1(setRefInitialized, function(param) {
            return true;
        });
    };
    $g85JO.useEffect(function() {
        if (isIntersecting && !isVisible) {
            $iv6Yc._1(setIsVisible, function(param) {
                return true;
            });
            if (trackRenderedElementsWithId !== undefined && trackRenderedElementsWithId !== "") $9a243b44307d8f73$var$lazyRenderRenderedIds[trackRenderedElementsWithId] = true;
        }
    }, [
        isIntersecting
    ]);
    return /*#__PURE__*/ $g85JO.createElement("div", {
        ref: $5bEXW.Ref.callbackDomRef(setRef),
        className: $ezf3v.prefix("hide-on-empty")
    }, isVisible ? children : fallbackElement);
}
$9a243b44307d8f73$var$LazyRender.displayName = "LazyRender";
var $9a243b44307d8f73$export$dd44f18ab656f3bb = $9a243b44307d8f73$var$LazyRender;
 /* react Not a pure module */ 
});

parcelRegister("5ZuQ4", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $45ca922fdaecea44$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $jBCH6 = parcelRequire("jBCH6");

var $c6E1z = parcelRequire("c6E1z");

var $1xf0g = parcelRequire("1xf0g");

var $7E1DP = parcelRequire("7E1DP");

var $hBcYV = parcelRequire("hBcYV");

var $aSJcu = parcelRequire("aSJcu");

var $9pMGg = parcelRequire("9pMGg");

var $jtD5N = parcelRequire("jtD5N");

var $8E2YL = parcelRequire("8E2YL");

var $5bqtN = parcelRequire("5bqtN");
function $45ca922fdaecea44$var$QuickViewCard(Props) {
    var category = Props.category;
    var parentCategory = Props.parentCategory;
    var shape = Props.shape;
    var fluidOpt = Props.fluid;
    var roundedOpt = Props.rounded;
    var showTitleOpt = Props.showTitle;
    var showDescriptionOpt = Props.showDescription;
    var showTaggedProductsOpt = Props.showTaggedProducts;
    var enableViewProductButtonOpt = Props.enableViewProductButton;
    var imageFitToContainer = Props.imageFitToContainer;
    var style = Props.style;
    var onClick = Props.onClick;
    var onOverlayProductClick = Props.onOverlayProductClick;
    var onImageRendered = Props.onImageRendered;
    var fluid = fluidOpt !== undefined ? fluidOpt : false;
    var rounded = roundedOpt !== undefined ? roundedOpt : true;
    var showTitle = showTitleOpt !== undefined ? showTitleOpt : true;
    var showDescription = showDescriptionOpt !== undefined ? showDescriptionOpt : true;
    var showTaggedProducts = showTaggedProductsOpt !== undefined ? showTaggedProductsOpt : true;
    var enableViewProductButton = enableViewProductButtonOpt !== undefined ? enableViewProductButtonOpt : true;
    var productCategory = $2whNH.getWithDefault(parentCategory, category);
    var enableViewProductButton$1 = enableViewProductButton && shape !== /* Circle */ 0;
    var displayVariantBy = $jtD5N.useDisplayVariantBy(undefined);
    var match = $8E2YL.use(undefined);
    var match$1 = match.config;
    var settings = match$1.settings;
    var match$2 = $9pMGg.use(undefined);
    var onOpenLink = match$2.onOpenLink;
    var match$3 = $aSJcu.use(undefined);
    var match$4 = $hBcYV.useRouter(undefined);
    var imageFitToContainer$1 = $2whNH.getWithDefault(imageFitToContainer, settings.categoryCardFitToContainer);
    var showTaggedProducts$1 = !match$4.isQuickView && showTaggedProducts;
    var productIds = $g85JO.useMemo(function() {
        return $1xf0g.getProductIds(category);
    }, [
        category
    ]);
    var match$5 = $c6E1z.useProductsById(match$1.transitiveStoreId, productIds, settings.hideOutOfStock, true, productCategory.id, match$2.smartnavApiHost, match$2.market, undefined);
    var products = $2whNH.getWithDefault(match$5.products, []);
    var data = $g85JO.useMemo(function() {
        var data = category.categoryType;
        if (typeof data === "number") return;
        switch(data.TAG | 0){
            case /* Standard */ 1:
                return data._0;
            case /* QuickView */ 2:
                var data$1 = data._0;
                return {
                    firstCard: data$1.firstCard,
                    externalConnection: data$1.externalConnection,
                    children: data$1.children,
                    loadMoreChildren: data$1.loadMoreChildren,
                    totalChildren: data$1.totalChildren,
                    link: data$1.link,
                    products: data$1.products,
                    taggedMedia: undefined,
                    imageHotspots: data$1.imageHotspots,
                    imageWidth: data$1.imageWidth,
                    imageHeight: data$1.imageHeight
                };
            default:
                return;
        }
    }, [
        category.categoryType
    ]);
    var onOverlayButtonClick = $g85JO.useCallback(function(param) {
        $2whNH.forEach(onClick, function(onClick) {
            $iv6Yc._2(onClick, parentCategory, category);
        });
    }, [
        category
    ]);
    var onOverlayProductClick$1 = $g85JO.useCallback(function(product) {
        return function(variant) {
            if (settings.openProductLink) return $iv6Yc._5(onOpenLink, productCategory, undefined, product, variant, undefined);
            else return $2whNH.forEach(onOverlayProductClick, function(fn) {
                $iv6Yc._4(fn, category, parentCategory, product, variant);
            });
        };
    }, [
        category,
        settings.openProductLink,
        onOpenLink,
        onOverlayProductClick
    ]);
    var match$6 = category.categoryType;
    var match$7 = $1xf0g.Link.getCardFallbackLink(category);
    var buttonKind;
    var exit = 0;
    if (typeof match$6 === "number" || match$6.TAG !== /* QuickView */ 2) exit = 1;
    else {
        var match$8 = match$6._0;
        if (match$8.isPinned) buttonKind = /* Pin */ 6;
        else if (match$8.children.length !== 0) buttonKind = /* ViewAlbum */ 4;
        else exit = 1;
    }
    if (exit === 1) buttonKind = products.length !== 0 ? /* ViewProducts */ 2 : match$7 !== undefined ? /* LearnMore */ {
        _0: match$7
    } : /* ViewZoom */ 3;
    var pins = $g85JO.useMemo(function() {
        return $2whNH.getWithDefault($2whNH.map(data, function(data) {
            return $2whNH.getWithDefault($2whNH.map(data.imageHotspots, function(pins) {
                return $i7mYY.keepMap($i7mYY.map(pins, function(__x) {
                    return $jBCH6.fromDTO(__x, products);
                }), function(p) {
                    return p;
                });
            }), $jBCH6.fromTaggedProducts(data.products, products));
        }), []);
    }, [
        data,
        products
    ]);
    var visibility = match$3.isMobile ? /* AlwaysShow */ 1 : /* AutoHide */ 0;
    var renderOverlay = $g85JO.useCallback(data !== undefined ? $2whNH.isSome(data.imageHotspots) ? function(param) {
        var tmp = {
            size: /* Lg */ 1,
            dynamicTooltipWidth: true,
            productCardShape: settings.productCardShape,
            pins: pins,
            active: true,
            visibility: visibility,
            enableButton: enableViewProductButton$1,
            buttonKind: buttonKind,
            buttonMargin: "0 0 6px 8px",
            showPins: showTaggedProducts$1,
            displayVariantBy: displayVariantBy,
            imageFitToContainer: settings.productCardFitToContainer,
            openLinkInNewTab: settings.openLinkInNewTab,
            hideOutOfStock: settings.hideOutOfStock,
            onClickButton: onOverlayButtonClick,
            onClickPin: onOverlayProductClick$1
        };
        var tmp$1 = imageFitToContainer$1 ? "contain" : undefined;
        if (tmp$1 !== undefined) tmp.fit = tmp$1;
        if (data.imageWidth !== undefined) tmp.width = data.imageWidth;
        if (data.imageHeight !== undefined) tmp.height = data.imageHeight;
        return /*#__PURE__*/ $g85JO.createElement($5bqtN.Hotspots.make, tmp);
    } : function(param) {
        var tmp = {
            pins: pins,
            active: true,
            visibility: visibility,
            enableButton: enableViewProductButton$1,
            productCardShape: settings.productCardShape,
            buttonKind: buttonKind,
            buttonMargin: "0 0 6px 8px",
            showStack: showTaggedProducts$1,
            displayVariantBy: displayVariantBy,
            hideOutOfStock: settings.hideOutOfStock,
            imageFitToContainer: settings.productCardFitToContainer,
            openLinkInNewTab: settings.openLinkInNewTab,
            onClickButton: onOverlayButtonClick,
            onClickThumbnail: onOverlayProductClick$1
        };
        var tmp$1 = settings.productCardFitToContainer ? /* Contain */ 2 : undefined;
        if (tmp$1 !== undefined) tmp.imageFit = $loT9g.valFromOption(tmp$1);
        return /*#__PURE__*/ $g85JO.createElement($5bqtN.Stack.make, tmp);
    } : function(param) {
        return null;
    }, [
        data,
        pins,
        settings,
        buttonKind,
        enableViewProductButton$1,
        displayVariantBy,
        showTaggedProducts$1,
        onOverlayButtonClick,
        onOverlayProductClick$1
    ]);
    var titleTextSize = shape === /* Circle */ 0 ? /* Base */ 2 : undefined;
    var onClickTemp = $g85JO.useCallback(function(category) {
        $2whNH.forEach(onClick, function(onClick) {
            $iv6Yc._2(onClick, parentCategory, category);
        });
    }, [
        category
    ]);
    var onClick$1 = onClick !== undefined ? onClickTemp : undefined;
    var tmp = {
        category: category,
        shape: shape,
        fluid: fluid,
        renderOverlay: renderOverlay,
        showVideoIndicator: true,
        showTitle: showTitle,
        rounded: rounded,
        showDescription: showDescription,
        videoControlsClassName: $ezf3v.prefix("z-20"),
        imageFitToContainer: imageFitToContainer$1
    };
    if (titleTextSize !== undefined) tmp.titleTextSize = $loT9g.valFromOption(titleTextSize);
    if (style !== undefined) tmp.style = $loT9g.valFromOption(style);
    if (onClick$1 !== undefined) tmp.onClick = $loT9g.valFromOption(onClick$1);
    if (onImageRendered !== undefined) tmp.onImageRendered = $loT9g.valFromOption(onImageRendered);
    return /*#__PURE__*/ $g85JO.createElement($7E1DP.make, tmp);
}
$45ca922fdaecea44$var$QuickViewCard.displayName = "QuickViewCard";
var $45ca922fdaecea44$export$dd44f18ab656f3bb = $45ca922fdaecea44$var$QuickViewCard;
 /* react Not a pure module */ 
});
parcelRegister("jBCH6", function(module, exports) {

$parcel$export(module.exports, "fromTaggedProducts", function () { return $e45f7cde3a941435$export$674147e33e814bd4; });
$parcel$export(module.exports, "fromDTO", function () { return $e45f7cde3a941435$export$d64306423b89b41b; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $7KlbQ = parcelRequire("7KlbQ");
function $e45f7cde3a941435$export$674147e33e814bd4(taggedProducts, products) {
    return $i7mYY.mapWithIndex($i7mYY.keepMap($i7mYY.map(taggedProducts, function(taggedProduct) {
        return [
            taggedProduct,
            $7KlbQ.getProductById(products, taggedProduct.productId)
        ];
    }), function(param) {
        var b = param[1];
        if (b !== undefined) return [
            param[0],
            b
        ];
    }), function(i, param) {
        return {
            id: String(i),
            x: 0,
            y: 0,
            variantId: param[0].variantId,
            product: param[1]
        };
    });
}
function $e45f7cde3a941435$export$d64306423b89b41b(pin, products) {
    var product = $7KlbQ.getProductById(products, pin.productId);
    var visible = $2whNH.getWithDefault(pin.visible, true);
    if (product !== undefined && visible) return {
        id: pin.id,
        x: pin.x,
        y: pin.y,
        variantId: pin.variantId,
        product: product
    };
}
 /* Product-Showside Not a pure module */ 
});

parcelRegister("5bqtN", function(module, exports) {

$parcel$export(module.exports, "Stack", function () { return $3c62851f9cb93c3d$export$694e0d28c7ffc90c; });
$parcel$export(module.exports, "Hotspots", function () { return $3c62851f9cb93c3d$export$626529642aaf0118; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $kQvlq = parcelRequire("kQvlq");

var $7KlbQ = parcelRequire("7KlbQ");

var $55MCT = parcelRequire("55MCT");

var $3WcEQ = parcelRequire("3WcEQ");

var $lPfnp = parcelRequire("lPfnp");

var $5bEXW = parcelRequire("5bEXW");

var $cTjaa = parcelRequire("cTjaa");

var $6Y4PS = parcelRequire("6Y4PS");

var $jBcRb = parcelRequire("jBcRb");

var $9EMq4 = parcelRequire("9EMq4");

var $aSJcu = parcelRequire("aSJcu");

var $9pMGg = parcelRequire("9pMGg");

var $9CbCT = parcelRequire("9CbCT");
function $3c62851f9cb93c3d$var$QuickViewProductsOverlay$Stack(Props) {
    var pins = Props.pins;
    var fullscreenOpt = Props.fullscreen;
    var imageFitOpt = Props.imageFit;
    var activeOpt = Props.active;
    var visibilityOpt = Props.visibility;
    var enableButtonOpt = Props.enableButton;
    var productCardShapeOpt = Props.productCardShape;
    var buttonKindOpt = Props.buttonKind;
    var buttonText = Props.buttonText;
    var buttonTextColor = Props.buttonTextColor;
    var buttonBackgroundColor = Props.buttonBackgroundColor;
    var buttonIconLink = Props.buttonIconLink;
    var onClickOpt = Props.onClick;
    var highlightProductRef = Props.highlightProductRef;
    var margin = Props.margin;
    var buttonMargin = Props.buttonMargin;
    var showStackOpt = Props.showStack;
    var showProductTooltipOpt = Props.showProductTooltip;
    var displayVariantByOpt = Props.displayVariantBy;
    var hideOutOfStockOpt = Props.hideOutOfStock;
    var imageFitToContainerOpt = Props.imageFitToContainer;
    var openLinkInNewTabOpt = Props.openLinkInNewTab;
    var onClickButton = Props.onClickButton;
    var onClickThumbnail = Props.onClickThumbnail;
    var canCollapse = Props.canCollapse;
    var fullscreen = fullscreenOpt !== undefined ? fullscreenOpt : false;
    var imageFit = imageFitOpt !== undefined ? imageFitOpt : /* Cover */ 1;
    var active = activeOpt !== undefined ? activeOpt : false;
    var visibility = visibilityOpt !== undefined ? visibilityOpt : /* AutoHide */ 0;
    var enableButton = enableButtonOpt !== undefined ? enableButtonOpt : true;
    var productCardShape = productCardShapeOpt !== undefined ? productCardShapeOpt : /* Square */ 1;
    var buttonKind = buttonKindOpt !== undefined ? buttonKindOpt : /* ViewProducts */ 2;
    var onClick = onClickOpt !== undefined ? onClickOpt : function onClick(param) {};
    var showStack = showStackOpt !== undefined ? showStackOpt : true;
    var showProductTooltip = showProductTooltipOpt !== undefined ? showProductTooltipOpt : false;
    var displayVariantBy = displayVariantByOpt !== undefined ? displayVariantByOpt : /* FirstVariant */ 0;
    var hideOutOfStock = hideOutOfStockOpt !== undefined ? hideOutOfStockOpt : true;
    var imageFitToContainer = imageFitToContainerOpt !== undefined ? imageFitToContainerOpt : false;
    var openLinkInNewTab = openLinkInNewTabOpt !== undefined ? openLinkInNewTabOpt : false;
    var match = $aSJcu.use(undefined);
    var isMobile = match.isMobile;
    var match$1 = $9pMGg.use(undefined);
    var trackEvent = match$1.trackEvent;
    var elRef = $g85JO.useRef(null);
    var bounds = $cTjaa.useResizeObserver(undefined, elRef);
    var match$2 = $kQvlq.useSafeTimeout(undefined, undefined);
    var clearExitTimeout = match$2.clearTimeout;
    var setExitTimeout = match$2.setTimeout;
    var match$3 = $g85JO.useState(function() {});
    var setHighlightedProduct = match$3[1];
    var highlightedProduct = match$3[0];
    $g85JO.useEffect(function() {
        if (highlightProductRef !== undefined) {
            highlightProductRef.current = function(product) {
                $iv6Yc._1(setHighlightedProduct, function(param) {
                    return product;
                });
            };
            return function(param) {
                highlightProductRef.current = function(param) {};
            };
        }
    }, []);
    var maxThumbnails = $2whNH.getWithDefault($2whNH.map(bounds, function(bounds) {
        return (bounds.height - 120 | 0) / 48 | 0;
    }), 1);
    var maxThumbnails$1 = maxThumbnails > 1 ? maxThumbnails : 1;
    var match$4 = $g85JO.useState(function() {
        return false;
    });
    var setMouseOver = match$4[1];
    var mouseOver = match$4[0];
    var match$5 = $g85JO.useState(function() {
        return false;
    });
    var setThumbnailsMouseOver = match$5[1];
    var thumbnailsMouseOver = match$5[0];
    var match$6 = $g85JO.useState(function() {
        return false;
    });
    var setIntroPlaying = match$6[1];
    $g85JO.useEffect(function() {
        var timeoutId = setTimeout(function(param) {
            if (active) return $iv6Yc._1(setIntroPlaying, function(param) {
                return false;
            });
        }, 4000);
        if (active) $iv6Yc._1(setIntroPlaying, function(param) {
            return true;
        });
        return function(param) {
            clearTimeout(timeoutId);
        };
    }, [
        active
    ]);
    var pins$1 = $i7mYY.slice(pins, 0, maxThumbnails$1);
    var products = $i7mYY.map(pins$1, function(pin) {
        return pin.product;
    });
    var isVisible;
    switch(visibility){
        case /* AutoHide */ 0:
            isVisible = match$6[0] || mouseOver;
            break;
        case /* AlwaysShow */ 1:
            isVisible = true;
            break;
        case /* ShowOnHover */ 2:
            isVisible = mouseOver;
            break;
        case /* AlwaysHide */ 3:
            isVisible = false;
            break;
    }
    var renderProductTooltip = function renderProductTooltip(pin) {
        var product = pin.product;
        var variant = $7KlbQ.getInitialDisplayVariant(hideOutOfStock, pin.variantId, displayVariantBy, product);
        var widthPx = Math.max(Math.min($2whNH.mapWithDefault(bounds, 1000, function(bounds) {
            return bounds.width - 70 | 0;
        }), 320), 110);
        var style = {
            width: $ezf3v.intToPx(widthPx)
        };
        var showProductTooltip$1 = showProductTooltip && widthPx > 160;
        var handleProductClick = function handleProductClick(product, variant) {
            $iv6Yc._2(onClickThumbnail, product, variant);
            $iv6Yc.app(trackEvent, [
                "Clicked In-Media Product Card",
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined,
                undefined
            ]);
        };
        if (showProductTooltip$1) return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "group-2-hover:opacity-100 group-2-hover:pointer-events-auto pointer-events-none opacity-0",
                "transition-opacity duration-250",
                "absolute left-13.5 top-0"
            ])),
            style: style
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("bg-main ml-2 p-2.5 rounded-custom w-full h-full shadow-xl")
        }, /*#__PURE__*/ $g85JO.createElement($6Y4PS.make, {
            product: product,
            variant: variant,
            shape: productCardShape,
            imageFitStrategy: imageFitToContainer ? /* Contain */ 2 : /* Cover */ 1,
            flushed: false,
            padding: false,
            hideOutOfStock: hideOutOfStock,
            onClick: handleProductClick,
            enableDataTestId: false,
            displayVariantBy: displayVariantBy
        })));
        else return null;
    };
    var total = products.length;
    var renderThumbnails = function renderThumbnails(param) {
        return $i7mYY.mapWithIndex(pins$1, function(i, p) {
            var product = p.product;
            var variant = $7KlbQ.getInitialDisplayVariant(hideOutOfStock, p.variantId, displayVariantBy, product);
            var tilt = i - (total - (4 < maxThumbnails$1 ? 4 : maxThumbnails$1) | 0) | 0;
            var x = String(8 + (thumbnailsMouseOver ? 0 : (tilt > 0 ? tilt : 0) << 1) | 0);
            var y = String(8 + (thumbnailsMouseOver ? Math.imul(i, 48) : Math.imul(tilt > 0 ? tilt : 0, 3)) | 0);
            var angle = String(thumbnailsMouseOver ? 0 : Math.imul(tilt > 0 ? tilt : 0, 5));
            var imageSrc = $2whNH.getWithDefault($7KlbQ.Media.getImageUrlWithPosterFallback(variant.media), "");
            var highlighted = highlightedProduct !== undefined ? product.id === highlightedProduct.id : false;
            return /*#__PURE__*/ $g85JO.createElement("div", {
                key: product.id,
                className: $ezf3v.prefix("absolute transition-transform duration-200 pointer-events-auto -m-4 p-4"),
                style: {
                    transform: "translate(" + x + "px, " + y + "px) rotate(" + angle + "deg)"
                }
            }, /*#__PURE__*/ $g85JO.createElement($jBcRb.make, {
                className: "swiper-no-swiping",
                onClick: function onClick(e) {
                    e.stopPropagation();
                    e.preventDefault();
                    $iv6Yc.app(trackEvent, [
                        "Clicked Product Stack Thumbnail",
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined,
                        undefined
                    ]);
                    var isTopThumbnail = i === (total - 1 | 0);
                    $iv6Yc._1(setThumbnailsMouseOver, function(param) {
                        return true;
                    });
                    if (!isTopThumbnail || !isMobile || thumbnailsMouseOver || products.length === 1) return $iv6Yc._2(onClickThumbnail, product, variant);
                },
                children: /*#__PURE__*/ $g85JO.createElement("div", {
                    className: $ezf3v.prefix($1TRFX.make([
                        "group-2 relative transition-all transform duration-500 bg-white flex justify-center items-center shadow",
                        (thumbnailsMouseOver || tilt === 0) && highlighted ? "scale-105" : "scale-100"
                    ])),
                    style: {
                        height: "40px",
                        width: "40px"
                    }
                }, /*#__PURE__*/ $g85JO.createElement($55MCT.Sized.make, {
                    src: imageSrc,
                    containerWidth: 40,
                    containerHeight: 40,
                    fit: imageFit,
                    priority: 0,
                    alt: p.product.name
                }), renderProductTooltip(p)),
                dataId: product.id,
                dataTestId: "qv-product-stack-item"
            }));
        });
    };
    var renderButton = function renderButton(param) {
        var onClick$1 = $2whNH.getWithDefault(onClickButton, onClick);
        if (!enableButton) return null;
        var tmp = {
            kind: buttonKind,
            at: /* Card */ 0,
            size: /* Small */ 0,
            openLinkInNewTab: openLinkInNewTab,
            collapsed: !isVisible,
            isMobile: isMobile,
            onClick: onClick$1
        };
        if (buttonText !== undefined) tmp.text = $loT9g.valFromOption(buttonText);
        if (buttonTextColor !== undefined) tmp.textColor = $loT9g.valFromOption(buttonTextColor);
        if (buttonBackgroundColor !== undefined) tmp.backgroundColor = $loT9g.valFromOption(buttonBackgroundColor);
        if (buttonIconLink !== undefined) tmp.iconLink = $loT9g.valFromOption(buttonIconLink);
        if (buttonMargin !== undefined) tmp.margin = $loT9g.valFromOption(buttonMargin);
        if (canCollapse !== undefined) tmp.canCollapse = $loT9g.valFromOption(canCollapse);
        return /*#__PURE__*/ $g85JO.createElement($9CbCT.make, tmp);
    };
    var margin$1 = $2whNH.flatMap(margin, function(marginFn) {
        return $2whNH.map(bounds, marginFn);
    });
    var tmp;
    if (showStack) {
        var tmp$1 = {};
        if (margin$1 !== undefined) tmp$1.margin = margin$1;
        tmp = /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "transition-opacity duration-200",
                isVisible ? "opacity-100" : "opacity-0"
            ])),
            style: tmp$1,
            onMouseEnter: function onMouseEnter(param) {
                if (!isMobile) {
                    $iv6Yc._1(clearExitTimeout, undefined);
                    return $iv6Yc._1(setThumbnailsMouseOver, function(param) {
                        return true;
                    });
                }
            },
            onMouseLeave: function onMouseLeave(param) {
                if (!isMobile) return setExitTimeout(function(param) {
                    $iv6Yc._1(setThumbnailsMouseOver, function(param) {
                        return false;
                    });
                }, 1000);
            }
        }, renderThumbnails(undefined));
    } else tmp = null;
    return /*#__PURE__*/ $g85JO.createElement("div", {
        ref: $5bEXW.Ref.domRef(elRef),
        className: $ezf3v.prefix($1TRFX.make([
            "absolute top-0 left-0 right-0 bottom-0",
            fullscreen ? "pointer-events-none" : ""
        ])),
        onClick: function onClick1(param) {
            $iv6Yc._1(onClick, undefined);
        },
        onMouseEnter: function onMouseEnter(param) {
            $iv6Yc._1(setMouseOver, function(param) {
                return true;
            });
        },
        onMouseLeave: function onMouseLeave(param) {
            $iv6Yc._1(setMouseOver, function(param) {
                return false;
            });
        }
    }, tmp, renderButton(undefined));
}
$3c62851f9cb93c3d$var$QuickViewProductsOverlay$Stack.displayName = "QuickViewProductsOverlay.Stack";
var $3c62851f9cb93c3d$export$694e0d28c7ffc90c = {
    make: $3c62851f9cb93c3d$var$QuickViewProductsOverlay$Stack
};
function $3c62851f9cb93c3d$var$QuickViewProductsOverlay$Hotspots(Props) {
    var sizeOpt = Props.size;
    var dynamicTooltipWidthOpt = Props.dynamicTooltipWidth;
    var productCardShapeOpt = Props.productCardShape;
    var pins = Props.pins;
    var fitOpt = Props.fit;
    var widthOpt = Props.width;
    var heightOpt = Props.height;
    var pinScaleOpt = Props.pinScale;
    var fullscreenOpt = Props.fullscreen;
    var activeOpt = Props.active;
    var visibilityOpt = Props.visibility;
    var dotColor = Props.dotColor;
    var enableButtonOpt = Props.enableButton;
    var buttonText = Props.buttonText;
    var buttonTextColor = Props.buttonTextColor;
    var buttonBackgroundColor = Props.buttonBackgroundColor;
    var buttonIconLink = Props.buttonIconLink;
    var buttonKindOpt = Props.buttonKind;
    var dotStyle = Props.dotStyle;
    var buttonMargin = Props.buttonMargin;
    var classNameOpt = Props.className;
    var highlightProductRef = Props.highlightProductRef;
    var showPinsOpt = Props.showPins;
    var displayVariantByOpt = Props.displayVariantBy;
    var imageFitToContainerOpt = Props.imageFitToContainer;
    var openLinkInNewTabOpt = Props.openLinkInNewTab;
    var hideOutOfStockOpt = Props.hideOutOfStock;
    var renderPinWrapperOpt = Props.renderPinWrapper;
    var onClickOpt = Props.onClick;
    var onClickButton = Props.onClickButton;
    var onClickPin = Props.onClickPin;
    var canCollapse = Props.canCollapse;
    var size = sizeOpt !== undefined ? sizeOpt : /* Base */ 0;
    var dynamicTooltipWidth = dynamicTooltipWidthOpt !== undefined ? dynamicTooltipWidthOpt : false;
    var productCardShape = productCardShapeOpt !== undefined ? productCardShapeOpt : /* Square */ 1;
    var fit = fitOpt !== undefined ? fitOpt : "cover";
    var width = widthOpt !== undefined ? widthOpt : 0;
    var height = heightOpt !== undefined ? heightOpt : 0;
    var pinScale = pinScaleOpt !== undefined ? pinScaleOpt : 1.0;
    var fullscreen = fullscreenOpt !== undefined ? fullscreenOpt : false;
    var active = activeOpt !== undefined ? activeOpt : false;
    var visibility = visibilityOpt !== undefined ? visibilityOpt : /* AutoHide */ 0;
    var enableButton = enableButtonOpt !== undefined ? enableButtonOpt : true;
    var buttonKind = buttonKindOpt !== undefined ? buttonKindOpt : /* ViewProducts */ 2;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var showPins = showPinsOpt !== undefined ? showPinsOpt : true;
    var displayVariantBy = displayVariantByOpt !== undefined ? displayVariantByOpt : /* FirstVariant */ 0;
    var imageFitToContainer = imageFitToContainerOpt !== undefined ? imageFitToContainerOpt : false;
    var openLinkInNewTab = openLinkInNewTabOpt !== undefined ? openLinkInNewTabOpt : false;
    var hideOutOfStock = hideOutOfStockOpt !== undefined ? hideOutOfStockOpt : true;
    var renderPinWrapper = renderPinWrapperOpt !== undefined ? renderPinWrapperOpt : function renderPinWrapper(a, b) {
        return b;
    };
    var onClick = onClickOpt !== undefined ? onClickOpt : function onClick(param) {};
    var match = $aSJcu.use(undefined);
    var isMobile = match.isMobile;
    var match$1 = $9pMGg.use(undefined);
    var trackEvent = match$1.trackEvent;
    var ref = $g85JO.useRef(null);
    var match$2 = $g85JO.useState(function() {});
    var setHighlightedPin = match$2[1];
    var highlightedPin = match$2[0];
    $g85JO.useEffect(function() {
        if (highlightProductRef !== undefined) {
            highlightProductRef.current = function(product) {
                $iv6Yc._1(setHighlightedPin, function(param) {
                    return product;
                });
            };
            return function(param) {
                highlightProductRef.current = function(param) {};
            };
        }
    }, []);
    var bounds = $9EMq4.useResizeObserver(ref);
    var match$3 = $g85JO.useState(function() {
        return false;
    });
    var setMouseOver = match$3[1];
    var mouseOver = match$3[0];
    var match$4 = $g85JO.useState(function() {
        return false;
    });
    var setPinsOn = match$4[1];
    var pinsOn = match$4[0];
    var match$5 = $g85JO.useState(function() {
        return false;
    });
    var setIntroPlaying = match$5[1];
    $g85JO.useEffect(function() {
        var timeoutId = active ? ($iv6Yc._1(setIntroPlaying, function(param) {
            return true;
        }), $loT9g.some(setTimeout(function(param) {
            $iv6Yc._1(setIntroPlaying, function(param) {
                return false;
            });
        }, 4000))) : undefined;
        return function(param) {
            $2whNH.forEach(timeoutId, function(prim) {
                clearTimeout(prim);
            });
        };
    }, [
        active
    ]);
    var renderPin = function renderPin(pin) {
        var highlighted = highlightedPin !== undefined ? pin.product.id === highlightedPin.id : undefined;
        if (bounds === undefined) return null;
        var tmp = {
            size: size,
            dynamicTooltipWidth: dynamicTooltipWidth,
            shape: productCardShape,
            pin: pin,
            onClick: onClickPin,
            scale: pinScale,
            bounds: bounds,
            highlighted: highlighted,
            enableTip: !isMobile,
            imageFitToContainer: imageFitToContainer,
            hideOutOfStock: hideOutOfStock,
            displayVariantBy: displayVariantBy,
            trackEvent: trackEvent,
            mediaWidth: width,
            mediaHeight: height,
            key: pin.id
        };
        if (dotColor !== undefined) tmp.dotColor = $loT9g.valFromOption(dotColor);
        if (dotStyle !== undefined) tmp.dotStyle = $loT9g.valFromOption(dotStyle);
        return $iv6Yc._2(renderPinWrapper, pin, /*#__PURE__*/ $g85JO.createElement($3WcEQ.make, tmp));
    };
    var isVisible;
    switch(visibility){
        case /* AutoHide */ 0:
            isVisible = match$5[0] || mouseOver || pinsOn;
            break;
        case /* AlwaysShow */ 1:
            isVisible = true;
            break;
        case /* ShowOnHover */ 2:
            isVisible = mouseOver;
            break;
        case /* AlwaysHide */ 3:
            isVisible = false;
            break;
    }
    var renderButton = function renderButton(param) {
        var onClick$1 = $2whNH.getWithDefault(onClickButton, onClick);
        if (!enableButton) return null;
        var tmp = {
            kind: buttonKind,
            at: /* Card */ 0,
            size: /* Small */ 0,
            openLinkInNewTab: openLinkInNewTab,
            collapsed: !isVisible,
            isMobile: isMobile,
            onClick: onClick$1
        };
        if (buttonText !== undefined) tmp.text = $loT9g.valFromOption(buttonText);
        if (buttonTextColor !== undefined) tmp.textColor = $loT9g.valFromOption(buttonTextColor);
        if (buttonBackgroundColor !== undefined) tmp.backgroundColor = $loT9g.valFromOption(buttonBackgroundColor);
        if (buttonIconLink !== undefined) tmp.iconLink = $loT9g.valFromOption(buttonIconLink);
        if (buttonMargin !== undefined) tmp.margin = $loT9g.valFromOption(buttonMargin);
        if (canCollapse !== undefined) tmp.canCollapse = $loT9g.valFromOption(canCollapse);
        return /*#__PURE__*/ $g85JO.createElement($9CbCT.make, tmp);
    };
    var fitCalc = $lPfnp.fitAndPosition({
        width: $2whNH.mapWithDefault(bounds, 0, function(s) {
            return s.width;
        }),
        height: $2whNH.mapWithDefault(bounds, 0, function(s) {
            return s.height;
        })
    }, {
        width: width,
        height: height
    }, fit);
    var style = {
        height: "" + fitCalc.height.toString() + "px",
        width: "" + fitCalc.width.toString() + "px"
    };
    return /*#__PURE__*/ $g85JO.createElement("div", {
        ref: $5bEXW.Ref.domRef(ref),
        className: $1TRFX.make([
            $ezf3v.prefix("absolute top-0 left-0 w-full h-full"),
            fullscreen ? $ezf3v.prefix("pointer-events-none") : "",
            className
        ]),
        onClick: function onClick(param) {
            if (fullscreen) {
                $iv6Yc._1(setPinsOn, function(on) {
                    return !on;
                });
                if (pinsOn) return $iv6Yc.app(trackEvent, [
                    "Clicked Product Pins Tips Off",
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined
                ]);
                else return $iv6Yc.app(trackEvent, [
                    "Clicked Product Pins Tips On",
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined,
                    undefined
                ]);
            }
        },
        onMouseEnter: function onMouseEnter(param) {
            $iv6Yc._1(setMouseOver, function(param) {
                return true;
            });
        },
        onMouseLeave: function onMouseLeave(param) {
            $iv6Yc._1(setMouseOver, function(param) {
                return false;
            });
        }
    }, showPins ? /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 transition-opacity duration-300",
            isVisible || isMobile ? "opacity-100" : "opacity-0"
        ])),
        style: style
    }, $i7mYY.map(pins, renderPin)) : null, fullscreen ? null : renderButton(undefined));
}
$3c62851f9cb93c3d$var$QuickViewProductsOverlay$Hotspots.displayName = "QuickViewProductsOverlay.Hotspots";
var $3c62851f9cb93c3d$export$626529642aaf0118 = {
    make: $3c62851f9cb93c3d$var$QuickViewProductsOverlay$Hotspots
};
 /* react Not a pure module */ 
});
parcelRegister("3WcEQ", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $2de09b747fd1df78$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $81N94 = parcelRequire("81N94");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $kQxJU = parcelRequire("kQxJU");

var $7KlbQ = parcelRequire("7KlbQ");

var $55MCT = parcelRequire("55MCT");

var $8lNXy = parcelRequire("8lNXy");

var $gCzsf = parcelRequire("gCzsf");

var $5bEXW = parcelRequire("5bEXW");

var $8L1B1 = parcelRequire("8L1B1");

var $bN9Qr = parcelRequire("bN9Qr");

var $fUtdg = parcelRequire("fUtdg");

var $5av24 = parcelRequire("5av24");

var $6Y4PS = parcelRequire("6Y4PS");

var $jBcRb = parcelRequire("jBcRb");

var $9EMq4 = parcelRequire("9EMq4");

var $eng6F = parcelRequire("eng6F");
function $2de09b747fd1df78$var$ProductPin(Props) {
    var sizeOpt = Props.size;
    var dynamicTooltipWidthOpt = Props.dynamicTooltipWidth;
    var shape = Props.shape;
    var pin = Props.pin;
    var onClick = Props.onClick;
    var dotColor = Props.dotColor;
    var scaleOpt = Props.scale;
    var bounds = Props.bounds;
    var dotStyle = Props.dotStyle;
    var highlighted = Props.highlighted;
    var enableTipOpt = Props.enableTip;
    var imageFitToContainerOpt = Props.imageFitToContainer;
    var hideOutOfStockOpt = Props.hideOutOfStock;
    var displayVariantByOpt = Props.displayVariantBy;
    var trackEvent = Props.trackEvent;
    var mediaWidth = Props.mediaWidth;
    var mediaHeight = Props.mediaHeight;
    var size = sizeOpt !== undefined ? sizeOpt : /* Base */ 0;
    var dynamicTooltipWidth = dynamicTooltipWidthOpt !== undefined ? dynamicTooltipWidthOpt : false;
    var scale = scaleOpt !== undefined ? scaleOpt : 1.0;
    var enableTip = enableTipOpt !== undefined ? enableTipOpt : false;
    var imageFitToContainer = imageFitToContainerOpt !== undefined ? imageFitToContainerOpt : false;
    var hideOutOfStock = hideOutOfStockOpt !== undefined ? hideOutOfStockOpt : true;
    var displayVariantBy = displayVariantByOpt !== undefined ? displayVariantByOpt : /* FirstVariant */ 0;
    var store = $8L1B1.use(undefined);
    var canUseBounds = size ? true : false;
    var tipRef = $g85JO.useRef(null);
    var tipBounds = $9EMq4.useResizeObserver(tipRef);
    var tipWidth = size ? dynamicTooltipWidth ? Math.min(Math.max(bounds.width - 20 | 0, 114), 320) : 320 : 114;
    var tipHeight = tipBounds !== undefined ? $81N94.int_min(118, 65 > tipBounds.height ? 65 : tipBounds.height) : size ? 118 : 65;
    var sx = bounds.width / mediaWidth * scale;
    var sy = bounds.height / mediaHeight * scale;
    var enableTip$1 = mediaWidth * sx < 320 ? false : enableTip;
    var tipLeft = pin.x * sx - tipWidth / 2.0 | 0;
    var tipRight = pin.x * sx + tipWidth / 2.0 | 0;
    var tipBottom = pin.y * sy + tipHeight | 0;
    var flipped = (tipBottom + (10 / sy | 0) | 0) > bounds.height;
    var pushRight = tipLeft < 0.0 ? (-tipLeft | 0) + 10 | 0 : 0;
    var pushLeft = tipRight > bounds.width ? tipRight - bounds.width + 10 | 0 : 0;
    var dx = (pushRight - pushLeft | 0) - (tipWidth / 2 | 0) | 0;
    var maxLimit = (-tipWidth | 0) - 10 | 0;
    var minLimit = tipWidth + 10 | 0;
    var dx$1 = $81N94.int_max(maxLimit, minLimit < dx ? minLimit : dx);
    var dy = flipped ? (-tipHeight | 0) - 24 | 0 : 0;
    var x = pin.x;
    var y = pin.y;
    var xPercent = (x / mediaWidth * 100.0).toString() + "%";
    var yPercent = (y / mediaHeight * 100.0).toString() + "%";
    var containerStyle = {
        left: xPercent,
        padding: "22px",
        top: yPercent,
        transform: "translate(-22px, -22px) scale(" + scale.toString() + ")"
    };
    var dotStyle$1;
    if (dotStyle !== undefined) {
        var tmp = {};
        if (dotColor !== undefined) tmp.backgroundColor = dotColor;
        dotStyle$1 = Object.assign({}, tmp, $loT9g.valFromOption(dotStyle));
    } else {
        var tmp$1 = {};
        if (dotColor !== undefined) tmp$1.backgroundColor = dotColor;
        dotStyle$1 = tmp$1;
    }
    var popupStyle = {
        height: $ezf3v.intToPx(tipHeight),
        left: $ezf3v.intToPx(dx$1),
        top: $ezf3v.intToPx(dy),
        width: $ezf3v.intToPx(tipWidth)
    };
    var variant = $7KlbQ.getInitialDisplayVariant(hideOutOfStock, pin.variantId, displayVariantBy, pin.product);
    var imgSrc = $2whNH.getWithDefault($7KlbQ.Media.getImageUrlWithPosterFallback(variant.media), "");
    var onClick$1 = function onClick$1(e) {
        e.stopPropagation();
        e.preventDefault();
        $2whNH.forEach(onClick, function(callback) {
            $iv6Yc._2(callback, pin.product, variant);
        });
        $iv6Yc.app(trackEvent, [
            "Clicked Product Pin",
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined,
            undefined
        ]);
    };
    var renderImage = function renderImage(param) {
        if (size) return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("relative w-24 rounded overflow-hidden flex-shrink-0 flex aspect-ratio-4/3")
        }, /*#__PURE__*/ $g85JO.createElement($55MCT.make, {
            src: imgSrc,
            fit: /* Contain */ 2,
            alt: pin.product.name,
            priority: 0
        }));
        else return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("relative w-16 h-16 rounded overflow-hidden flex-shrink-0 flex")
        }, /*#__PURE__*/ $g85JO.createElement($55MCT.Sized.make, {
            src: imgSrc,
            containerWidth: 48,
            containerHeight: 48,
            fit: imageFitToContainer ? /* Contain */ 2 : /* Cover */ 1,
            priority: 0,
            alt: pin.product.name
        }));
    };
    var renderProductTitle = function renderProductTitle(param) {
        return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "text-primary overflow-hidden",
                size ? "text-lg" : "text-md leading-tight"
            ]))
        }, /*#__PURE__*/ $g85JO.createElement($5av24.make, {
            lines: 2,
            dataTestId: "qv-pin-card-title",
            children: $7KlbQ.getDisplayName(store, variant, pin.product)
        }));
    };
    var renderProductPrice = function renderProductPrice(param) {
        return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("truncate mt-1 text-secondary")
        }, size ? /*#__PURE__*/ $g85JO.createElement($8lNXy.make, {
            at: /* PLP */ 1,
            product: pin.product,
            variant: variant,
            size: /* Xl */ 0,
            showMaxPrice: true
        }) : /*#__PURE__*/ $g85JO.createElement($8lNXy.make, {
            at: /* PLP */ 1,
            product: pin.product,
            variant: variant,
            size: /* Sm */ 2,
            showMaxPrice: false
        }));
    };
    var renderProductReviews = function renderProductReviews(param) {
        var match = pin.product.reviewSummary;
        if (size && match !== undefined) return /*#__PURE__*/ $g85JO.createElement($fUtdg.Summary.make, {
            at: /* PLP */ 1,
            summary: match
        });
        else return null;
    };
    var highlightedCn = highlighted !== undefined && highlighted ? "scale-115 animate-beacon-outline shadow-outline" : "scale-100";
    var dot = /*#__PURE__*/ $g85JO.createElement($gCzsf.make, {
        dataTestId: "qv-pin",
        dataId: pin.id,
        children: size ? /*#__PURE__*/ $g85JO.createElement("div", {
            className: $1TRFX.make([
                $ezf3v.prefix("animate-grow-in scale-0 transform absolute inset-0 no-touch-highlight"),
                "swiper-no-swiping"
            ])
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "relative",
                "rounded-full bg-white w-6 h-6",
                "-ml-3 -mt-3 left-1/2 top-1/2",
                "drop-shadow-lg filter",
                "no-touch-highlight",
                "transform",
                "transition-all duration-150 ease-fastoutslow",
                highlightedCn
            ])),
            style: dotStyle$1
        })) : /*#__PURE__*/ $g85JO.createElement("div", {
            className: $1TRFX.make([
                $ezf3v.prefix("rounded-full bg-white w-4 h-4 -ml-2 -mt-2 shadow-outline ease-fastoutslow"),
                "swiper-no-swiping"
            ]),
            style: dotStyle$1
        })
    });
    var pinContent = size ? /*#__PURE__*/ $g85JO.createElement($6Y4PS.make, {
        product: pin.product,
        variant: variant,
        shape: shape,
        imageFitStrategy: imageFitToContainer ? /* Contain */ 2 : /* Cover */ 1,
        flushed: false,
        padding: true,
        hideOutOfStock: hideOutOfStock,
        onClick: function onClick(param, param$1) {},
        enableDataTestId: false,
        displayVariantBy: displayVariantBy
    }) : /*#__PURE__*/ $g85JO.createElement($g85JO.Fragment, undefined, renderImage(undefined), /*#__PURE__*/ $g85JO.createElement("div", {
        className: $ezf3v.prefix($1TRFX.make([
            "flex-grow min-w-0 flex flex-col",
            size ? "space-y-2 ml-3" : "m-2"
        ]))
    }, renderProductReviews(undefined), renderProductTitle(undefined), renderProductPrice(undefined)));
    var tmp$2;
    if (enableTip$1) {
        var tmp$3 = {
            className: $ezf3v.prefix($1TRFX.make([
                "flex justify-start absolute",
                size ? "items-stretch" : "items-center h-full",
                "flex-grow w-full"
            ])),
            onClick: onClick$1,
            children: pinContent,
            hasText: true,
            dataId: pin.id,
            dataTestId: "qv-pin-card"
        };
        var tmp$4 = canUseBounds ? $loT9g.some($5bEXW.Ref.domRef(tipRef)) : undefined;
        if (tmp$4 !== undefined) tmp$3.fwdRef = $loT9g.valFromOption(tmp$4);
        tmp$2 = /*#__PURE__*/ $g85JO.createElement("div", {
            className: $1TRFX.make([
                $ezf3v.prefix("pin-tooltip absolute"),
                flipped ? $ezf3v.prefix("pin-tooltip--flipped") : $ezf3v.prefix("pin-tooltip"),
                "swiper-no-swiping"
            ])
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "absolute bg-main text-primary rounded-custom shadow-xl",
                flipped ? "-mt-2" : "mt-8",
                size === /* Lg */ 1 ? "" : "px-2",
                size === /* Lg */ 1 ? "flex items-center" : ""
            ])),
            style: popupStyle
        }, /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "absolute",
                size ? "-inset-8" : "-inset-4"
            ]))
        }), /*#__PURE__*/ $g85JO.createElement($jBcRb.make, tmp$3)), flipped ? /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("absolute")
        }, /*#__PURE__*/ $g85JO.createElement($eng6F.make, {
            className: $ezf3v.prefix("w-6 h-4 -ml-3 -mt-11 text-main")
        })) : /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix("absolute")
        }, /*#__PURE__*/ $g85JO.createElement($bN9Qr.make, {
            className: $ezf3v.prefix("top-0 w-6 h-4 -ml-3 mt-5 text-main")
        })));
    } else tmp$2 = null;
    return /*#__PURE__*/ $g85JO.createElement($kQxJU.make, {
        props: {
            "data-pin-id": pin.id,
            "data-product-id": pin.product.id
        },
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "pin absolute cursor-pointer w-14 h-14 no-touch-highlight",
                "pointer-events-auto hover:z-10"
            ])),
            style: containerStyle,
            onClick: onClick$1
        }, dot, tmp$2)
    });
}
$2de09b747fd1df78$var$ProductPin.displayName = "ProductPin";
var $2de09b747fd1df78$export$dd44f18ab656f3bb = $2de09b747fd1df78$var$ProductPin;
 /* react Not a pure module */ 
});
parcelRegister("bN9Qr", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $895be84a91fa2f4f$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");
function $895be84a91fa2f4f$var$IconTriangleUp(Props) {
    var className = Props.className;
    var tmp = {
        height: "10",
        width: "20",
        viewBox: "0 0 20 10"
    };
    if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M0 10 L10 0 L20 10",
        fill: "currentColor"
    }));
}
$895be84a91fa2f4f$var$IconTriangleUp.displayName = "IconTriangleUp";
var $895be84a91fa2f4f$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($895be84a91fa2f4f$var$IconTriangleUp);
 /* make Not a pure module */ 
});

parcelRegister("eng6F", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $a76fb51509a8be3f$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");
function $a76fb51509a8be3f$var$IconTriangleDown(Props) {
    var className = Props.className;
    var tmp = {
        height: "10",
        width: "20",
        viewBox: "0 0 20 10"
    };
    if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M0 0 L10 10 L20 0",
        fill: "currentColor"
    }));
}
$a76fb51509a8be3f$var$IconTriangleDown.displayName = "IconTriangleDown";
var $a76fb51509a8be3f$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($a76fb51509a8be3f$var$IconTriangleDown);
 /* make Not a pure module */ 
});


parcelRegister("9CbCT", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $7000ae6220068878$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $hDZmi = parcelRequire("hDZmi");

var $k4eOr = parcelRequire("k4eOr");

var $b38V4 = parcelRequire("b38V4");

var $7wIsS = parcelRequire("7wIsS");

var $bQL0M = parcelRequire("bQL0M");

var $eYgaM = parcelRequire("eYgaM");

var $2R61F = parcelRequire("2R61F");

var $dzlIC = parcelRequire("dzlIC");

var $5bEXW = parcelRequire("5bEXW");

var $hBcYV = parcelRequire("hBcYV");

var $dbL1G = parcelRequire("dbL1G");

var $jBcRb = parcelRequire("jBcRb");

var $9pMGg = parcelRequire("9pMGg");
function $7000ae6220068878$var$QuickViewOverlayButton(Props) {
    var kind = Props.kind;
    var at = Props.at;
    var sizeOpt = Props.size;
    var colorOpt = Props.color;
    var text = Props.text;
    var textColor = Props.textColor;
    var backgroundColor = Props.backgroundColor;
    var iconLink = Props.iconLink;
    var margin = Props.margin;
    var openLinkInNewTab = Props.openLinkInNewTab;
    var style = Props.style;
    var canCollapseOpt = Props.canCollapse;
    var showTextOpt = Props.showText;
    var collapsedOpt = Props.collapsed;
    var isMobile = Props.isMobile;
    var containerClassNameOpt = Props.containerClassName;
    var onTouchMove = Props.onTouchMove;
    var onTouchEnd = Props.onTouchEnd;
    var onClick = Props.onClick;
    var size = sizeOpt !== undefined ? sizeOpt : /* Large */ 2;
    var color = colorOpt !== undefined ? colorOpt : /* Clear */ 2;
    var canCollapse = canCollapseOpt !== undefined ? canCollapseOpt : true;
    var showText = showTextOpt !== undefined ? showTextOpt : true;
    var collapsed = collapsedOpt !== undefined ? collapsedOpt : false;
    var containerClassName = containerClassNameOpt !== undefined ? containerClassNameOpt : "";
    var match = $9pMGg.use(undefined);
    var redirectToLink = match.redirectToLink;
    var match$1 = $hBcYV.useRouter(undefined);
    var goTo = match$1.goTo;
    var mediaNodeId = at ? at._0.id : undefined;
    var tmp;
    if (text !== undefined) tmp = text;
    else if (typeof kind === "number") {
        if (kind >= 3) tmp = undefined;
        else switch(kind){
            case /* Close */ 0:
                tmp = undefined;
                break;
            case /* ViewDetails */ 1:
                tmp = "View Details";
                break;
            case /* ViewProducts */ 2:
                tmp = "View Products";
                break;
        }
    } else tmp = "Learn More";
    var alt = $2whNH.getWithDefault(tmp, "");
    var iconSizeInPx;
    switch(size){
        case /* Small */ 0:
            iconSizeInPx = 16;
            break;
        case /* Medium */ 1:
            iconSizeInPx = 18;
            break;
        case /* Large */ 2:
            iconSizeInPx = 24;
            break;
    }
    var icon;
    if (iconLink !== undefined) icon = /*#__PURE__*/ $g85JO.createElement($hDZmi.make, {
        className: $1TRFX.make([
            $ezf3v.prefix("absolute left-1/2 transform -translate-x-1/2"),
            "smartnav-quickview-button-icon"
        ]),
        src: iconLink,
        alt: alt
    });
    else if (typeof kind === "number") switch(kind){
        case /* Close */ 0:
            icon = /*#__PURE__*/ $g85JO.createElement($dbL1G.make, {
                className: $ezf3v.prefix($1TRFX.make([
                    "w-full h-full",
                    "-bottom-px relative"
                ]))
            });
            break;
        case /* ViewDetails */ 1:
            icon = /*#__PURE__*/ $g85JO.createElement($bQL0M.make, {
                className: $ezf3v.prefix("w-full h-full")
            });
            break;
        case /* ViewProducts */ 2:
            icon = /*#__PURE__*/ $g85JO.createElement($b38V4.make, {
                className: $ezf3v.prefix($1TRFX.make([
                    "w-full h-full",
                    "-bottom-px left-px relative"
                ]))
            });
            break;
        case /* ViewZoom */ 3:
            icon = /*#__PURE__*/ $g85JO.createElement($eYgaM.make, {
                className: $ezf3v.prefix("w-full h-full")
            });
            break;
        case /* ViewAlbum */ 4:
            icon = /*#__PURE__*/ $g85JO.createElement($2R61F.make, {
                className: $ezf3v.prefix("w-full h-full")
            });
            break;
        case /* Hidden */ 5:
            icon = null;
            break;
        case /* Pin */ 6:
            icon = /*#__PURE__*/ $g85JO.createElement($k4eOr.make, {
                className: $ezf3v.prefix($1TRFX.make([
                    "w-full h-full",
                    "-top-px relative"
                ]))
            });
            break;
    }
    else icon = /*#__PURE__*/ $g85JO.createElement($7wIsS.UilLinkAlt.make, {
        size: /* Px */ {
            _0: iconSizeInPx
        },
        className: $ezf3v.prefix("w-full h-full")
    });
    var text$1;
    if (showText) {
        if (text !== undefined) text$1 = text;
        else if (typeof kind === "number") {
            if (kind >= 3) text$1 = undefined;
            else switch(kind){
                case /* Close */ 0:
                    text$1 = undefined;
                    break;
                case /* ViewDetails */ 1:
                    text$1 = "View Details";
                    break;
                case /* ViewProducts */ 2:
                    text$1 = "View Products";
                    break;
            }
        } else text$1 = "Learn More";
    } else text$1 = undefined;
    var ref = $g85JO.useRef(null);
    var dataTestId = at ? typeof kind === "number" ? kind !== 0 ? kind >= 6 ? "qv-pinned-media-button" : "qv-expand-panel-button" : "qv-collapse-panel-button" : "qv-expand-panel-button" : typeof kind === "number" ? kind !== 0 ? kind >= 6 ? "qv-pinned-media-button" : "qv-expand-media-button" : "qv-collapse-media-button" : "qv-expand-media-button";
    var link = typeof kind === "number" ? undefined : kind._0;
    var collapsed$1 = collapsed || $2whNH.isNone(text$1) || isMobile && at === /* Card */ 0;
    var collapsed$2 = canCollapse && collapsed$1;
    var renderBaseButton = function renderBaseButton(className, icon, text, param) {
        var containerClassName$1 = $1TRFX.make([
            at ? $ezf3v.prefix("relative") : $ezf3v.prefix("absolute bottom-0 flex flex-start pointer-events-none"),
            canCollapse && showText ? $ezf3v.prefix("w-full") : "",
            kind === /* Hidden */ 5 ? $ezf3v.prefix("opacity-0") : "",
            containerClassName
        ]);
        var buttonClassName = $1TRFX.make([
            className,
            $ezf3v.prefix("flex items-center rounded-full whitespace-nowrap rounded-full pointer-events-auto text-base transiton-all duration-300"),
            kind === /* Hidden */ 5 ? "" : $ezf3v.prefix("pointer-events-auto"),
            collapsed$2 ? $ezf3v.prefix("max-w-0p") : $ezf3v.prefix("max-w-full")
        ]);
        var textClassName = $ezf3v.prefix($1TRFX.make([
            "overflow-hidden transition-all duration-300",
            collapsed$2 ? "opacity-0" : "opacity-100"
        ]));
        var iconClassName = $ezf3v.prefix("flex-shrink-0");
        var tmp = {};
        if (margin !== undefined) tmp.padding = margin;
        var containerStyle = tmp;
        var tmp$1 = {};
        if (backgroundColor !== undefined) tmp$1.backgroundColor = backgroundColor;
        if (textColor !== undefined) tmp$1.color = textColor;
        var buttonStyle = tmp$1;
        var buttonStyle$1 = $2whNH.mapWithDefault(style, buttonStyle, function(styleProp) {
            return Object.assign({}, styleProp, buttonStyle);
        });
        var onClick$1 = function onClick$1(e) {
            if (link === undefined) {
                if (typeof kind === "number") {
                    e.preventDefault();
                    return $iv6Yc._1(onClick, undefined);
                } else {
                    e.stopPropagation();
                    return;
                }
            }
            switch(link.TAG | 0){
                case /* URL */ 0:
                    return $iv6Yc._5(redirectToLink, undefined, undefined, undefined, openLinkInNewTab, link._0);
                case /* Category */ 1:
                    var match = link._0;
                    return $iv6Yc._3(goTo, undefined, undefined, {
                        TAG: /* ListPage */ 1,
                        _0: {
                            listPageType: {
                                TAG: /* Category */ 0,
                                _0: match.categoryId
                            },
                            viewPLP: false,
                            filters: match.filters,
                            sort: undefined
                        }
                    });
                case /* Product */ 2:
                    var match$1 = link._0;
                    var productCategoryId = match$1.productCategoryId;
                    return $iv6Yc._3(goTo, undefined, undefined, {
                        TAG: /* PDP */ 2,
                        _0: {
                            categoryId: productCategoryId,
                            productCategoryId: productCategoryId,
                            productId: match$1.productId,
                            variantId: match$1.variantId,
                            zoomedPhotoIndex: undefined
                        }
                    });
                case /* StoreCategory */ 3:
                    var match$2 = link._0;
                    return $iv6Yc._3(goTo, undefined, undefined, {
                        TAG: /* ListPage */ 1,
                        _0: {
                            listPageType: {
                                TAG: /* StoreCategory */ 2,
                                _0: {
                                    categoryId: match$2.categoryId,
                                    sourceNodeId: mediaNodeId
                                }
                            },
                            viewPLP: false,
                            filters: undefined,
                            sort: match$2.sortBy
                        }
                    });
                case /* CustomAction */ 4:
                    var match$3 = link._0;
                    $dzlIC.triggerCustomFunctionWithoutProducts(match$3.code, match$3.name, undefined, undefined);
                    return;
            }
        };
        var tmp$2 = {
            color: color,
            className: buttonClassName,
            onClick: onClick$1,
            children: null,
            flex: true,
            style: buttonStyle$1,
            hasText: true,
            dataTestId: dataTestId
        };
        if (onTouchMove !== undefined) tmp$2.onTouchMove = $loT9g.valFromOption(onTouchMove);
        if (onTouchEnd !== undefined) tmp$2.onTouchEnd = $loT9g.valFromOption(onTouchEnd);
        if (openLinkInNewTab !== undefined) tmp$2.openLinkInNewTab = $loT9g.valFromOption(openLinkInNewTab);
        return /*#__PURE__*/ $g85JO.createElement("div", {
            ref: $5bEXW.Ref.domRef(ref),
            className: containerClassName$1,
            style: containerStyle
        }, /*#__PURE__*/ $g85JO.createElement($jBcRb.make, tmp$2, /*#__PURE__*/ $g85JO.createElement("div", {
            className: iconClassName
        }, icon), /*#__PURE__*/ $g85JO.createElement("div", {
            className: textClassName
        }, text)));
    };
    switch(size){
        case /* Small */ 0:
            var icon$1 = /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("w-5.5 h-5.5")
            }, icon);
            var text$2 = $2whNH.mapWithDefault(text$1, null, function(text) {
                return /*#__PURE__*/ $g85JO.createElement("div", {
                    className: $ezf3v.prefix("px-2")
                }, text);
            });
            var className = $ezf3v.prefix("p-1.5 min-w-8");
            return renderBaseButton(className, icon$1, text$2, undefined);
        case /* Medium */ 1:
            var icon$2 = /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("w-6 h-6")
            }, icon);
            var text$3 = $2whNH.mapWithDefault(text$1, null, function(text) {
                return /*#__PURE__*/ $g85JO.createElement("div", {
                    className: $ezf3v.prefix("text-base pl-3 pr-1")
                }, text);
            });
            var className$1 = $ezf3v.prefix("p-2 min-w-10");
            return renderBaseButton(className$1, icon$2, text$3, undefined);
        case /* Large */ 2:
            var icon$3 = color >= 2 ? /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("w-8 h-8")
            }, icon) : /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("flex items-center justify-center w-8 h-8")
            }, /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("w-6 h-6")
            }, icon));
            var text$4 = $2whNH.mapWithDefault(text$1, null, function(text) {
                return /*#__PURE__*/ $g85JO.createElement("div", {
                    className: $ezf3v.prefix("text-lg pl-3 pr-1.5")
                }, text);
            });
            var className$2 = $ezf3v.prefix("p-2.5 min-w-13");
            return renderBaseButton(className$2, icon$3, text$4, undefined);
    }
}
$7000ae6220068878$var$QuickViewOverlayButton.displayName = "QuickViewOverlayButton";
var $7000ae6220068878$export$dd44f18ab656f3bb = $7000ae6220068878$var$QuickViewOverlayButton;
 /* react Not a pure module */ 
});
parcelRegister("hDZmi", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $cd85acc1430ac0b1$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $g85JO = parcelRequire("g85JO");

var $ezf3v = parcelRequire("ezf3v");
function $cd85acc1430ac0b1$var$Icon(Props) {
    var classNameOpt = Props.className;
    var src = Props.src;
    var alt = Props.alt;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    var className$1 = $1TRFX.make([
        className,
        $ezf3v.prefix("object-contain w-full h-full")
    ]);
    return /*#__PURE__*/ $g85JO.createElement("img", {
        className: className$1,
        alt: alt,
        src: src
    });
}
$cd85acc1430ac0b1$var$Icon.displayName = "Icon";
var $cd85acc1430ac0b1$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($cd85acc1430ac0b1$var$Icon);
 /* make Not a pure module */ 
});

parcelRegister("k4eOr", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $e9bfabdad4b7a78d$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");
function $e9bfabdad4b7a78d$var$IconPin(Props) {
    var className = Props.className;
    return /*#__PURE__*/ $g85JO.createElement("svg", {
        "aria-label": "Pinned post icon",
        className: className,
        role: "img",
        height: "22",
        width: "22",
        fill: "#ffffff",
        viewBox: "0 0 24 24"
    }, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "m22.707 7.583-6.29-6.29a1 1 0 0 0-1.414 0 5.183 5.183 0 0 0-1.543 3.593L8.172 8.79a5.161 5.161 0 0 0-4.768 1.42 1 1 0 0 0 0 1.414l3.779 3.778-5.89 5.89a1 1 0 1 0 1.414 1.414l5.89-5.89 3.778 3.779a1 1 0 0 0 1.414 0 5.174 5.174 0 0 0 1.42-4.769l3.905-5.287a5.183 5.183 0 0 0 3.593-1.543 1 1 0 0 0 0-1.414Z"
    }));
}
$e9bfabdad4b7a78d$var$IconPin.displayName = "IconPin";
var $e9bfabdad4b7a78d$export$dd44f18ab656f3bb = $e9bfabdad4b7a78d$var$IconPin;
 /* react Not a pure module */ 
});

parcelRegister("b38V4", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $80b6e4ba5862738d$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");
function $80b6e4ba5862738d$var$IconTag(Props) {
    var className = Props.className;
    var tmp = {
        height: "22",
        width: "22",
        fill: "none",
        viewBox: "0 0 22 22",
        xmlns: "http://www.w3.org/2000/svg"
    };
    if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M0.5 0.953125V11.4531L11 21.9531L21.5 11.4531L11 0.953125H0.5ZM5.75 7.70312C4.90625 7.70312 4.25 7.04688 4.25 6.20312C4.25 5.40625 4.90625 4.70312 5.75 4.70312C6.54688 4.70312 7.25 5.40625 7.25 6.20312C7.25 7.04688 6.54688 7.70312 5.75 7.70312Z",
        fill: "currentColor"
    }));
}
$80b6e4ba5862738d$var$IconTag.displayName = "IconTag";
var $80b6e4ba5862738d$export$dd44f18ab656f3bb = $80b6e4ba5862738d$var$IconTag;
 /* react Not a pure module */ 
});

parcelRegister("bQL0M", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $8a09048fc72622ac$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");
function $8a09048fc72622ac$var$IconInfo(Props) {
    var classNameOpt = Props.className;
    var className = classNameOpt !== undefined ? classNameOpt : "";
    return /*#__PURE__*/ $g85JO.createElement("svg", {
        className: className,
        viewBox: "0 0 512 512",
        xmlns: "http://www.w3.org/2000/svg"
    }, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M256 512c141.4 0 256-114.6 256-256S397.4 0 256 0S0 114.6 0 256S114.6 512 256 512zM216 336h24V272H216 192V224h24 48 24v24 88h8 24v48H296 216 192V336h24zm72-144H224V128h64v64z",
        fill: "currentColor"
    }));
}
$8a09048fc72622ac$var$IconInfo.displayName = "IconInfo";
var $8a09048fc72622ac$export$dd44f18ab656f3bb = $8a09048fc72622ac$var$IconInfo;
 /* react Not a pure module */ 
});

parcelRegister("eYgaM", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $ae6336e10fe13ee9$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");
function $ae6336e10fe13ee9$var$IconZoom(Props) {
    var className = Props.className;
    var tmp = {
        viewBox: "0 0 512 512",
        xmlns: "http://www.w3.org/2000/svg"
    };
    if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M376 330.7c25.2-34.4 40-76.8 40-122.7C416 93.1 322.9 0 208 0S0 93.1 0 208S93.1 416 208 416c45.9 0 88.3-14.9 122.7-40L441.4 486.6 464 509.3 509.3 464l-22.6-22.6L376 330.7zM232 104v24 56h56 24v48H288 232v56 24H184V288 232H128 104V184h24 56V128 104h48z",
        fill: "currentColor"
    }));
}
$ae6336e10fe13ee9$var$IconZoom.displayName = "IconZoom";
var $ae6336e10fe13ee9$export$dd44f18ab656f3bb = $ae6336e10fe13ee9$var$IconZoom;
 /* react Not a pure module */ 
});

parcelRegister("2R61F", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $214534a2af93b15f$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");
function $214534a2af93b15f$var$IconAlbum(Props) {
    var className = Props.className;
    var tmp = {
        height: "1em",
        width: "1em",
        fill: "currentColor",
        stroke: "currentColor",
        strokeWidth: "0",
        viewBox: "0 0 512 512",
        xmlns: "http://www.w3.org/2000/svg"
    };
    if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M464 0c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48H176c-26.51 0-48-21.49-48-48V48c0-26.51 21.49-48 48-48h288M176 416c-44.112 0-80-35.888-80-80V128H48c-26.51 0-48 21.49-48 48v288c0 26.51 21.49 48 48 48h288c26.51 0 48-21.49 48-48v-48H176z"
    }));
}
$214534a2af93b15f$var$IconAlbum.displayName = "IconAlbum";
var $214534a2af93b15f$export$dd44f18ab656f3bb = $214534a2af93b15f$var$IconAlbum;
 /* react Not a pure module */ 
});

parcelRegister("dbL1G", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $99a0c7de78763dbf$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $g85JO = parcelRequire("g85JO");

var $loT9g = parcelRequire("loT9g");
function $99a0c7de78763dbf$var$IconChevronDown(Props) {
    var className = Props.className;
    var tmp = {
        height: "15",
        width: "23",
        fill: "none",
        viewBox: "0 0 23 15",
        xmlns: "http://www.w3.org/2000/svg"
    };
    if (className !== undefined) tmp.className = $loT9g.valFromOption(className);
    return /*#__PURE__*/ $g85JO.createElement("svg", tmp, /*#__PURE__*/ $g85JO.createElement("path", {
        d: "M11.5 14.1094L12.5312 13.0312L22.6094 2.95312L20.5 0.84375L11.5 9.84375L3.53125 1.92188L2.5 0.84375L0.34375 2.95312L11.5 14.1094Z",
        fill: "currentColor"
    }));
}
$99a0c7de78763dbf$var$IconChevronDown.displayName = "IconChevronDown";
var $99a0c7de78763dbf$export$dd44f18ab656f3bb = $99a0c7de78763dbf$var$IconChevronDown;
 /* react Not a pure module */ 
});




parcelRegister("lcQc5", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $f703349db0d2a38c$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $IFWJb = parcelRequire("IFWJb");

var $insiF = parcelRequire("insiF");

var $5bEXW = parcelRequire("5bEXW");

var $aSJcu = parcelRequire("aSJcu");
function $f703349db0d2a38c$var$ListPageSlider(Props) {
    var id = Props.id;
    var rowsOpt = Props.rows;
    var children = Props.children;
    var shouldCenterOpt = Props.shouldCenter;
    var slidesPerView = Props.slidesPerView;
    var gapOpt = Props.gap;
    var effectOpt = Props.effect;
    var navOpt = Props.nav;
    var transitionOpt = Props.transition;
    var transitionSpeedOpt = Props.transitionSpeed;
    var autoplayOpt = Props.autoplay;
    var autoplayDelayOpt = Props.autoplayDelay;
    var loopOpt = Props.loop;
    var duplicateSlidesForLoopingAutoplayOpt = Props.duplicateSlidesForLoopingAutoplay;
    var padding = Props.padding;
    var verticalPaddingOpt = Props.verticalPadding;
    var maxWidth = Props.maxWidth;
    var firstSlide = Props.firstSlide;
    var lastSlide = Props.lastSlide;
    var enableScrollbarOpt = Props.enableScrollbar;
    var enableNavigationOpt = Props.enableNavigation;
    var enableDotsOpt = Props.enableDots;
    var onInit = Props.onInit;
    var className = Props.className;
    var rows = rowsOpt !== undefined ? rowsOpt : 1;
    var shouldCenter = shouldCenterOpt !== undefined ? shouldCenterOpt : false;
    var gap = gapOpt !== undefined ? gapOpt : /* Equal */ 0;
    var effect = effectOpt !== undefined ? effectOpt : /* EffectSlide */ 0;
    var nav = navOpt !== undefined ? navOpt : /* NavAuto */ 0;
    var transition = transitionOpt !== undefined ? transitionOpt : /* TransitionEase */ 0;
    var transitionSpeed = transitionSpeedOpt !== undefined ? transitionSpeedOpt : 300;
    var autoplay = autoplayOpt !== undefined ? autoplayOpt : false;
    var autoplayDelay = autoplayDelayOpt !== undefined ? autoplayDelayOpt : 3000;
    var loop = loopOpt !== undefined ? loopOpt : false;
    var duplicateSlidesForLoopingAutoplay = duplicateSlidesForLoopingAutoplayOpt !== undefined ? duplicateSlidesForLoopingAutoplayOpt : false;
    var verticalPadding = verticalPaddingOpt !== undefined ? verticalPaddingOpt : false;
    var enableScrollbar = enableScrollbarOpt !== undefined ? enableScrollbarOpt : true;
    var enableNavigation = enableNavigationOpt !== undefined ? enableNavigationOpt : true;
    var enableDots = enableDotsOpt !== undefined ? enableDotsOpt : true;
    var match = $aSJcu.use(undefined);
    var isMobile = match.isMobile;
    var enableScrollbar$1 = enableScrollbar && (nav === /* NavScrollbar */ 2 || nav === /* NavAuto */ 0 && !isMobile);
    var enableNavigation$1 = enableNavigation && (nav === /* NavArrows */ 1 || nav === /* NavAuto */ 0 && !isMobile);
    var enablePagination = enableDots && nav === /* NavDots */ 3;
    var swiperEffect = effect ? "fade" : undefined;
    var transition$1;
    switch(transition){
        case /* TransitionEase */ 0:
            transition$1 = "ease";
            break;
        case /* TransitionLinear */ 1:
            transition$1 = "linear";
            break;
        case /* TransitionEaseIn */ 2:
            transition$1 = "ease-in";
            break;
        case /* TransitionEaseOut */ 3:
            transition$1 = "ease-out";
            break;
        case /* TransitionEaseInOut */ 4:
            transition$1 = "ease-in-out";
            break;
    }
    var ref = $g85JO.useRef(null);
    $IFWJb.use(undefined);
    var rows$1 = Math.max(rows, 1);
    var needsMarginBottom = rows$1 > 1;
    var start = function start(children) {
        return $i7mYY.concat(firstSlide !== undefined ? [
            $loT9g.valFromOption(firstSlide)
        ] : [], children);
    };
    var end = function end(children) {
        return $i7mYY.concat(children, lastSlide !== undefined ? [
            $loT9g.valFromOption(lastSlide)
        ] : []);
    };
    var spaceBetweenCn;
    if (typeof gap === "number") switch(gap){
        case /* Equal */ 0:
            spaceBetweenCn = $1TRFX.make([
                "mr-col-custom",
                needsMarginBottom ? "mb-col-custom" : ""
            ]);
            break;
        case /* Half */ 1:
            spaceBetweenCn = $1TRFX.make([
                "mr-col-custom-half",
                needsMarginBottom ? "mb-col-custom-half" : ""
            ]);
            break;
        case /* Double */ 2:
            spaceBetweenCn = $1TRFX.make([
                "mr-col-custom-double",
                needsMarginBottom ? "mb-col-custom-double" : ""
            ]);
            break;
    }
    else spaceBetweenCn = "";
    var marginRight = typeof gap === "number" ? undefined : $ezf3v.intToPx(gap._0);
    var marginBottom = typeof gap === "number" || !needsMarginBottom ? undefined : $ezf3v.intToPx(gap._0);
    var slidesPerGroup = Math.max((Math.floor(slidesPerView) | 0) - 1 | 0, 1);
    var sliderOffset = padding !== undefined ? padding : isMobile ? 12 : 24;
    var slides = $g85JO.useMemo(function() {
        return $i7mYY.mapWithIndex(end(start(children)), function(i, el) {
            var tmp = {};
            if (marginRight !== undefined) tmp.marginRight = marginRight;
            if (marginBottom !== undefined) tmp.marginBottom = marginBottom;
            var style = tmp;
            return /*#__PURE__*/ $g85JO.createElement("div", {
                key: String(i),
                className: $ezf3v.prefix($1TRFX.make([
                    "flex flex-col",
                    spaceBetweenCn
                ])),
                style: style
            }, el);
        });
    }, [
        children
    ]);
    var maxWidth$1 = maxWidth !== undefined ? $ezf3v.intToPx(maxWidth) : undefined;
    var tmp = {
        marginRight: "auto",
        marginLeft: "auto"
    };
    if (maxWidth$1 !== undefined) tmp.maxWidth = maxWidth$1;
    var style = tmp;
    var tmp$1 = {
        items: slides,
        slidesOffsetBefore: sliderOffset,
        slidesOffsetAfter: sliderOffset,
        slidesPerView: /* Float */ {
            _0: slidesPerView
        },
        slidesPerGroup: slidesPerGroup,
        slidesPerColumn: rows$1,
        enableFreeMode: slidesPerView !== 1.0 && effect !== /* EffectFade */ 1 && !loop,
        centeredSlides: loop && !autoplay,
        centeredSlidesBounds: loop && !autoplay,
        centerInsufficientSlides: shouldCenter,
        enableScrollbar: enableScrollbar$1,
        dragScrollbar: true,
        enableNavigation: enableNavigation$1,
        enablePagination: enablePagination,
        enableMousewheel: true,
        enableAutoplay: autoplay,
        loop: loop,
        duplicateSlidesForLoopingAutoplay: duplicateSlidesForLoopingAutoplay,
        loopedSlides: Math.floor(slidesPerView),
        className: enableScrollbar$1 && !isMobile ? $ezf3v.prefix("pb-8") : "",
        restorationId: "quicknav-category-slider-" + id + "",
        autoplayDelay: autoplayDelay,
        transition: transition$1,
        transitionSpeed: transitionSpeed,
        dataTestId: "list-page-slider",
        dataId: id
    };
    if (swiperEffect !== undefined) tmp$1.effect = $loT9g.valFromOption(swiperEffect);
    if (onInit !== undefined) tmp$1.onInit = $loT9g.valFromOption(onInit);
    return /*#__PURE__*/ $g85JO.createElement("div", {
        ref: $5bEXW.Ref.domRef(ref),
        className: $1TRFX.make([
            $2whNH.getWithDefault(className, ""),
            verticalPadding ? $ezf3v.prefix("py-row-custom") : "",
            $ezf3v.prefix("w-full")
        ])
    }, /*#__PURE__*/ $g85JO.createElement("div", {
        className: $1TRFX.make([
            "swiper-auto-hide",
            isMobile ? "" : "swiper-large-navigation"
        ]),
        style: style
    }, /*#__PURE__*/ $g85JO.createElement($insiF.make, tmp$1)));
}
$f703349db0d2a38c$var$ListPageSlider.displayName = "ListPageSlider";
var $f703349db0d2a38c$export$dd44f18ab656f3bb = /*#__PURE__*/ $g85JO.memo($f703349db0d2a38c$var$ListPageSlider);
 /* make Not a pure module */ 
});

parcelRegister("gamGp", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $bc4f2ce4a668c839$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $1TRFX = parcelRequire("1TRFX");

var $g85JO = parcelRequire("g85JO");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $diVVk = parcelRequire("diVVk");

var $8E2YL = parcelRequire("8E2YL");
function $bc4f2ce4a668c839$var$PlaceholderCard(Props) {
    var title = Props.title;
    var showTitleOpt = Props.showTitle;
    var shape = Props.shape;
    var renderAfterTitle = Props.renderAfterTitle;
    var kind = Props.kind;
    var dataTestId = Props.dataTestId;
    var contentBoxStylableClassName = Props.contentBoxStylableClassName;
    var titleStylableClassName = Props.titleStylableClassName;
    var children = Props.children;
    var showTitle = showTitleOpt !== undefined ? showTitleOpt : true;
    var match = $8E2YL.use(undefined);
    var settings = match.config.settings;
    var randId = $g85JO.useRef(Math.random().toString()).current;
    var shape$1 = kind || typeof shape === "number" && !(shape > 3 || shape < 1) ? shape : settings.productCardShape;
    var lineClamp = kind ? settings.categoryCardTitleLineTruncate : settings.productCardTitleLineTruncate + 1 | 0;
    var backgroundCn = "bg-placeholder";
    var renderTitle = function renderTitle(param) {
        return /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "flex mt-4 flex-col space-y-4",
                shape$1 === /* Circle */ 0 ? "items-center" : "items-start"
            ]))
        }, $i7mYY.makeBy(lineClamp, function(i) {
            return /*#__PURE__*/ $g85JO.createElement("div", {
                key: String(i),
                className: $ezf3v.prefix($1TRFX.make([
                    "h-6 rounded",
                    i === (lineClamp - 1 | 0) ? "w-4/5" : "w-full",
                    backgroundCn
                ])),
                data: String(i)
            });
        }));
    };
    var tmp = {
        shape: shape$1,
        id: randId,
        lineClamp: 1,
        showTitle: showTitle,
        contentBoxStylableClassName: contentBoxStylableClassName,
        titleStylableClassName: titleStylableClassName,
        imageSize: [
            undefined,
            undefined
        ],
        renderTitle: renderTitle,
        children: /*#__PURE__*/ $g85JO.createElement("div", {
            className: $ezf3v.prefix($1TRFX.make([
                "h-full w-full",
                backgroundCn
            ]))
        }, $2whNH.getWithDefault(children, null))
    };
    if (title !== undefined) tmp.title = $loT9g.valFromOption(title);
    if (dataTestId !== undefined) tmp.dataTestId = $loT9g.valFromOption(dataTestId);
    if (renderAfterTitle !== undefined) tmp.renderAfterTitle = $loT9g.valFromOption(renderAfterTitle);
    return /*#__PURE__*/ $g85JO.createElement($diVVk.make, tmp);
}
$bc4f2ce4a668c839$var$PlaceholderCard.displayName = "PlaceholderCard";
var $bc4f2ce4a668c839$export$dd44f18ab656f3bb = $bc4f2ce4a668c839$var$PlaceholderCard;
 /* react Not a pure module */ 
});

parcelRegister("HqFR6", function(module, exports) {

$parcel$export(module.exports, "make", function () { return $0828b52f7e231b7e$export$dd44f18ab656f3bb; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $ezf3v = parcelRequire("ezf3v");

var $7wIsS = parcelRequire("7wIsS");

var $fsiJD = parcelRequire("fsiJD");

var $9EMq4 = parcelRequire("9EMq4");
function $0828b52f7e231b7e$var$InfiniteScrollProximitySensor(Props) {
    var error = Props.error;
    var numLoadedPages = Props.numLoadedPages;
    var numPages = Props.numPages;
    var setNumPages = Props.setNumPages;
    var viewport = Props.viewport;
    var renderChildren = Props.renderChildren;
    var children = Props.children;
    var increaseOffsetForMobileOpt = Props.increaseOffsetForMobile;
    var increaseOffsetForMobile = increaseOffsetForMobileOpt !== undefined ? increaseOffsetForMobileOpt : false;
    var match = $g85JO.useState(function() {
        return false;
    });
    var setVisible = match[1];
    var isVisible = match[0];
    var match$1 = $g85JO.useState(function() {
        return error;
    });
    var setError = match$1[1];
    var error$1 = match$1[0];
    $g85JO.useEffect(function() {
        $iv6Yc._1(setError, function(param) {
            return error;
        });
    }, [
        error
    ]);
    $g85JO.useEffect(function() {
        if (isVisible && numLoadedPages >= numPages && error$1 === undefined) $iv6Yc._1(setNumPages, numPages + 1 | 0);
    }, [
        isVisible,
        numPages,
        numLoadedPages,
        error$1
    ]);
    var handleRetry = function handleRetry(param) {
        $iv6Yc._1(setError, function(param) {});
        $iv6Yc._1(setNumPages, numPages + 1 | 0);
    };
    var viewportSize = $9EMq4.useWithWindowFallback(viewport);
    var vw = viewportSize.width;
    var vh = viewportSize.height;
    var vw$1 = increaseOffsetForMobile ? vw * 2.5 | 0 : vw;
    var offset_top = -vh | 0;
    var offset_left = -vw$1 | 0;
    var offset_right = -vw$1 | 0;
    var offset_bottom = -vh | 0;
    var offset = {
        top: offset_top,
        left: offset_left,
        right: offset_right,
        bottom: offset_bottom
    };
    var onChange = function onChange(nextIsVisible) {
        $iv6Yc._1(setVisible, function(param) {
            return nextIsVisible;
        });
    };
    var renderError = function renderError(param) {
        return $2whNH.mapWithDefault(error$1, null, function(e) {
            return /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("flex flex-col space-y-2 justify-center items-center h-full text-tertiary cursor-pointer"),
                onClick: handleRetry
            }, /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("text-center")
            }, /*#__PURE__*/ $g85JO.createElement($7wIsS.UilSync.make, {})), /*#__PURE__*/ $g85JO.createElement("div", {
                className: $ezf3v.prefix("text-center leading-normal")
            }, "Failed to fetch more. Retry?"));
        });
    };
    if (children !== undefined) {
        var tmp = {
            partialVisibility: true,
            onChange: onChange,
            children: $loT9g.valFromOption(children),
            offset: offset
        };
        var tmp$1 = $loT9g.nullable_to_opt(viewport.current);
        if (tmp$1 !== undefined) tmp.containment = $loT9g.valFromOption(tmp$1);
        return /*#__PURE__*/ $g85JO.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fsiJD))), tmp);
    }
    if (renderChildren === undefined) return null;
    var tmp$2 = {
        partialVisibility: true,
        onChange: onChange,
        children: $iv6Yc._1(renderChildren, renderError(undefined)),
        offset: offset
    };
    var tmp$3 = $loT9g.nullable_to_opt(viewport.current);
    if (tmp$3 !== undefined) tmp$2.containment = $loT9g.valFromOption(tmp$3);
    return /*#__PURE__*/ $g85JO.createElement((0, (/*@__PURE__*/$parcel$interopDefault($fsiJD))), tmp$2);
}
$0828b52f7e231b7e$var$InfiniteScrollProximitySensor.displayName = "InfiniteScrollProximitySensor";
var $0828b52f7e231b7e$export$dd44f18ab656f3bb = $0828b52f7e231b7e$var$InfiniteScrollProximitySensor;
 /* react Not a pure module */ 
});


parcelRegister("1z5jA", function(module, exports) {

$parcel$export(module.exports, "useRelatedMedia", function () { return $123d2ebc24e32906$export$726fd6217b623f08; });
$parcel$export(module.exports, "useSlider", function () { return $123d2ebc24e32906$export$56b2c08e277f365; });
$parcel$export(module.exports, "Slider", function () { return $123d2ebc24e32906$export$472062a354075cee; });
$parcel$export(module.exports, "Inline", function () { return $123d2ebc24e32906$export$fbae5b5ffd8af05e; });
// Generated by ReScript, PLEASE EDIT WITH CARE

var $iv6Yc = parcelRequire("iv6Yc");

var $g85JO = parcelRequire("g85JO");

var $7bjme = parcelRequire("7bjme");

var $i7mYY = parcelRequire("i7mYY");

var $2whNH = parcelRequire("2whNH");

var $loT9g = parcelRequire("loT9g");

var $c6E1z = parcelRequire("c6E1z");

var $16qP0 = parcelRequire("16qP0");

var $1xf0g = parcelRequire("1xf0g");

var $3QSSt = parcelRequire("3QSSt");

var $i3Bxr = parcelRequire("i3Bxr");

var $9MZLD = parcelRequire("9MZLD");

var $kMqPq = parcelRequire("kMqPq");

var $5ZuQ4 = parcelRequire("5ZuQ4");

var $hBcYV = parcelRequire("hBcYV");

var $hP9EI = parcelRequire("hP9EI");

var $aSJcu = parcelRequire("aSJcu");

var $9pMGg = parcelRequire("9pMGg");

var $8E2YL = parcelRequire("8E2YL");

var $hgUzV = parcelRequire("hgUzV");
function $123d2ebc24e32906$export$cb311135f149a25(isMobile, layout) {
    var match = layout.size;
    var match$1 = layout.shape;
    switch(match){
        case /* Small */ 0:
            if (match$1 === 1) {
                if (isMobile) return 5.2;
                else return 8.2;
            } else if (isMobile) return 5.2;
            else return 12.2;
        case /* Medium */ 1:
            if (match$1 === 1) {
                if (isMobile) return 4.2;
                else return 7.2;
            } else if (isMobile) return 4.8;
            else return 9.2;
        case /* Large */ 2:
            if (match$1 === 1) {
                if (isMobile) return 3.2;
                else return 6.2;
            } else if (isMobile) return 4.2;
            else return 8.2;
    }
}
function $123d2ebc24e32906$export$1cb657ee6a99c8fc(shape) {
    if (typeof shape === "number") switch(shape){
        case /* Tall */ 0:
            return /* Tall */ 6;
        case /* Square */ 1:
            return /* Square */ 1;
        case /* Circle */ 2:
            return /* Circle */ 0;
    }
    else {
        var match = shape._0;
        return /* Custom */ {
            _0: match.width,
            _1: match.height
        };
    }
}
function $123d2ebc24e32906$export$122a632893579567(apiHostname, live, backup, configId, storeId, hideOutOfStock, breakpoint, offset, offsetByNodeId, source) {
    var endpoint;
    endpoint = typeof source === "number" ? undefined : source.TAG === /* ByProductIds */ 0 ? "/api/get_related_media_by_products?product_ids=" + source._0.join(",") : "/api/get_related_media_by_category?category_id=" + source._0 + $2whNH.mapWithDefault(storeId, "", function(storeId) {
        return "&store_id=" + storeId;
    }) + (hideOutOfStock ? "&in_stock=true" : "");
    return $2whNH.map(endpoint, function(endpoint) {
        return apiHostname + endpoint + ("&config_id=" + configId) + (live ? "&live=true" : "") + $2whNH.mapWithDefault(backup, "", function(backup) {
            return "&backup=" + backup;
        }) + "&showside_format=true&breakpoint=" + breakpoint + ("&limit=" + String($kMqPq.nodeLimit)) + (offsetByNodeId !== undefined ? "&offset_by_node_id=" + offsetByNodeId : "&offset=" + String(offset)) + "&global=true";
    });
}
function $123d2ebc24e32906$export$726fd6217b623f08(count, shapeOpt, at, enabledOpt, source) {
    var shape = shapeOpt !== undefined ? shapeOpt : /* Square */ 1;
    var enabled = enabledOpt !== undefined ? enabledOpt : true;
    var match = $aSJcu.use(undefined);
    var match$1 = $hBcYV.useRouter(undefined);
    var previewMode = match$1.previewMode;
    var match$2 = $16qP0.use(undefined);
    var match$3 = $8E2YL.use(undefined);
    var match$4 = match$3.config;
    var transitiveAccount = match$4.transitiveAccount;
    var isEnabledInPLP = $2whNH.mapWithDefault(transitiveAccount, false, function(account) {
        return account.plpShowRelatedMedia;
    }) && enabled;
    var isEnabledInPDP = $2whNH.mapWithDefault(transitiveAccount, false, function(account) {
        return account.pdpShowRelatedMedia;
    }) && enabled;
    var source$1 = at !== 1 ? at !== 0 || isEnabledInPDP ? source : /* NoSource */ 0 : isEnabledInPLP ? source : /* NoSource */ 0;
    var live = previewMode !== undefined ? typeof previewMode === "number" ? previewMode !== 0 : false : true;
    var backup = previewMode !== undefined && typeof previewMode !== "number" ? previewMode._0.toString() : undefined;
    var apiUrl = $123d2ebc24e32906$export$122a632893579567(match$2.smartnavApiHost, live, backup, match$4.id, match$4.transitiveStoreId, match$4.settings.hideOutOfStock, $9MZLD.toString(match.breakpoint), 0, undefined, source$1);
    var apiUrl$1 = $3QSSt.usePreviousSome(apiUrl);
    var match$5 = $c6E1z.useCategories(apiUrl$1);
    var rawData = match$5.data;
    var placeholders = $g85JO.useMemo(function() {
        if (typeof source$1 === "number" || count === undefined) return;
        else return {
            categories: $i7mYY.makeBy(Math.min(count, $kMqPq.nodeLimit), function(index) {
                var id = "related-media-placeholder-" + String(index);
                var card = {
                    TAG: /* MedialessCard */ 4,
                    _0: {
                        link: undefined,
                        size: /* Md */ 4,
                        shape: $123d2ebc24e32906$export$1cb657ee6a99c8fc(shape)
                    }
                };
                var categoryType = {
                    TAG: /* QuickView */ 2,
                    _0: {
                        isStories: false,
                        isPinned: false,
                        firstCard: undefined,
                        externalConnection: undefined,
                        children: [],
                        loadMoreChildren: undefined,
                        totalChildren: count,
                        link: undefined,
                        products: [],
                        imageHotspots: undefined,
                        imageWidth: undefined,
                        imageHeight: undefined
                    }
                };
                var newrecord = $7bjme.obj_dup($hgUzV.empty);
                newrecord.categoryType = categoryType;
                newrecord.card = card;
                newrecord.showDescription = false;
                newrecord.showTitle = false;
                newrecord.id = id;
                return newrecord;
            }),
            previous: undefined,
            next: undefined,
            offset: 0,
            total: count
        };
    }, [
        count
    ]);
    var data = $2whNH.orElse(rawData, placeholders);
    return $g85JO.useMemo(function() {
        try {
            if (data === undefined) return;
            if (!(data.categories.length !== 0 && enabled)) return;
            var newrecord = $7bjme.obj_dup($hgUzV.empty);
            return newrecord.categoryType = {
                TAG: /* QuickView */ 2,
                _0: {
                    isStories: false,
                    isPinned: false,
                    firstCard: undefined,
                    externalConnection: undefined,
                    children: data.categories,
                    loadMoreChildren: data.next,
                    totalChildren: data.total,
                    link: undefined,
                    products: [],
                    imageHotspots: undefined,
                    imageWidth: undefined,
                    imageHeight: undefined
                }
            }, newrecord.card = {
                TAG: /* MedialessCard */ 4,
                _0: {
                    link: undefined,
                    size: /* Md */ 4,
                    shape: $123d2ebc24e32906$export$1cb657ee6a99c8fc(shape)
                }
            }, newrecord.title = "Related Media", newrecord.id = "related-media", newrecord;
        } catch (exn) {
            return;
        }
    }, [
        apiUrl$1,
        rawData,
        enabled
    ]);
}
function $123d2ebc24e32906$export$6cc285371d20f189(source) {
    var match = $hBcYV.useRouter(undefined);
    var goTo = match.goTo;
    var match$1 = $9pMGg.use(undefined);
    var onQuickViewClick = $g85JO.useCallback(function(parentCategory) {
        return function(category) {
            var tmp;
            tmp = typeof source === "number" || source.TAG !== /* ByProductIds */ 0 ? undefined : source._0;
            var tmp$1;
            tmp$1 = typeof source === "number" || source.TAG === /* ByProductIds */ 0 ? undefined : source._0;
            return $iv6Yc._3(goTo, undefined, undefined, {
                TAG: /* QuickView */ 3,
                _0: {
                    mediaId: category.id,
                    mediaParentId: "related-media",
                    albumId: undefined,
                    productId: undefined,
                    relatedMediaProductIds: tmp,
                    relatedMediaCategoryId: tmp$1,
                    variantId: undefined,
                    panelClosed: undefined,
                    zoomedPhotoIndex: undefined,
                    time: undefined
                }
            });
        };
    }, [
        goTo
    ]);
    var onOverlayProductClick = $g85JO.useCallback(function(category) {
        return function(parentCategory, product, variant) {
            var tmp;
            tmp = typeof source === "number" || source.TAG !== /* ByProductIds */ 0 ? undefined : source._0;
            var tmp$1;
            tmp$1 = typeof source === "number" || source.TAG === /* ByProductIds */ 0 ? undefined : source._0;
            return $iv6Yc._3(goTo, undefined, undefined, {
                TAG: /* QuickView */ 3,
                _0: {
                    mediaId: category.id,
                    mediaParentId: "related-media",
                    albumId: undefined,
                    productId: product.id,
                    relatedMediaProductIds: tmp,
                    relatedMediaCategoryId: tmp$1,
                    variantId: $2whNH.map(variant, function(variant) {
                        return variant.id;
                    }),
                    panelClosed: undefined,
                    zoomedPhotoIndex: undefined,
                    time: undefined
                }
            });
        };
    }, [
        goTo
    ]);
    return {
        onCategoryClick: match$1.onCategoryClick,
        onQuickViewClick: onQuickViewClick,
        onProductClick: match$1.onProductClick,
        onOverlayProductClick: onOverlayProductClick
    };
}
function $123d2ebc24e32906$export$56b2c08e277f365(count, at, scrollableContainerRef, source, shape, size, className, param) {
    var match = $8E2YL.use(undefined);
    var match$1 = match.config;
    var account = match$1.transitiveAccount;
    var layoutSettings = $g85JO.useMemo(function() {
        if (account !== undefined) {
            var layout = account.pdpRelatedMediaStyle;
            var exit = 0;
            if (layout !== undefined) {
                if (at === /* PDP */ 0) return layout;
                exit = 2;
            } else exit = 2;
            if (exit === 2) {
                var match = account.plpRelatedMediaStyle;
                if (match !== undefined && match.TAG === /* SliderLayout */ 0 && at === /* PLP */ 1) return match._0;
            }
        }
        return {
            shape: $2whNH.getWithDefault(shape, /* Square */ 1),
            size: $2whNH.getWithDefault(size, /* Medium */ 1)
        };
    }, [
        account
    ]);
    var category = $123d2ebc24e32906$export$726fd6217b623f08(count, layoutSettings.shape, at, undefined, source);
    var match$2 = $123d2ebc24e32906$export$6cc285371d20f189(source);
    var match$3 = $aSJcu.use(undefined);
    var isNarrowContainer = match$3.isMobile || match$1.settings.desktopPDPLayout === /* Old */ 0 && at === /* PDP */ 0;
    var layout = $g85JO.useMemo(function() {
        return {
            TAG: /* SliderLayout */ 0,
            _0: {
                slidesPerView: $123d2ebc24e32906$export$cb311135f149a25(isNarrowContainer, layoutSettings),
                gap: $i3Bxr.emptySliderPayload.gap,
                maxWidth: $i3Bxr.emptySliderPayload.maxWidth,
                padding: at === /* PDP */ 0 ? 0 : undefined,
                rows: $i3Bxr.emptySliderPayload.rows,
                effect: $i3Bxr.emptySliderPayload.effect,
                nav: $i3Bxr.emptySliderPayload.nav,
                transition: $i3Bxr.emptySliderPayload.transition,
                transitionSpeed: $i3Bxr.emptySliderPayload.transitionSpeed,
                autoplay: $i3Bxr.emptySliderPayload.autoplay,
                autoplayDelay: $i3Bxr.emptySliderPayload.autoplayDelay,
                loop: $i3Bxr.emptySliderPayload.loop
            }
        };
    }, [
        layoutSettings
    ]);
    if (category === undefined) return;
    var tmp = {
        category: category,
        scrollableContainerRef: scrollableContainerRef,
        layout: layout,
        index: 0,
        forcedHideTitle: true,
        forcedHideDescription: true,
        onOverlayProductClick: match$2.onOverlayProductClick,
        onCategoryClick: match$2.onCategoryClick,
        onQuickViewClick: match$2.onQuickViewClick,
        onProductClick: match$2.onProductClick
    };
    if (className !== undefined) tmp.className = className;
    return $loT9g.some(/*#__PURE__*/ $g85JO.createElement($hP9EI.make, tmp));
}
function $123d2ebc24e32906$var$RelatedMediaContent$Slider(Props) {
    var count = Props.count;
    var at = Props.at;
    var scrollableContainerRef = Props.scrollableContainerRef;
    var source = Props.source;
    var shape = Props.shape;
    var size = Props.size;
    var className = Props.className;
    return $2whNH.getWithDefault($123d2ebc24e32906$export$56b2c08e277f365(count, at, scrollableContainerRef, source, shape, size, className, undefined), null);
}
$123d2ebc24e32906$var$RelatedMediaContent$Slider.displayName = "RelatedMediaContent.Slider";
var $123d2ebc24e32906$export$472062a354075cee = {
    make: $123d2ebc24e32906$var$RelatedMediaContent$Slider
};
function $123d2ebc24e32906$var$useInlineRelatedMedia(count, at, parentCategory, enabled, source) {
    $hBcYV.useRouter(undefined);
    var match = $123d2ebc24e32906$export$6cc285371d20f189(source);
    var onOverlayProductClick = match.onOverlayProductClick;
    var onQuickViewClick = match.onQuickViewClick;
    var cardShape = $1xf0g.CategoryCard.getCardShape(undefined, undefined, parentCategory.card);
    return $2whNH.map($2whNH.map($123d2ebc24e32906$export$726fd6217b623f08(count, undefined, at, enabled, source), $1xf0g.getChildren), function(categories) {
        return $i7mYY.map(categories, function(category, fluid, shape) {
            return /*#__PURE__*/ $g85JO.createElement($5ZuQ4.make, {
                category: category,
                parentCategory: parentCategory,
                shape: $2whNH.getWithDefault(shape, cardShape),
                fluid: fluid,
                showTitle: false,
                enableViewProductButton: true,
                onClick: onQuickViewClick,
                onOverlayProductClick: onOverlayProductClick,
                key: parentCategory.id + category.id
            });
        });
    });
}
var $123d2ebc24e32906$export$fbae5b5ffd8af05e = {
    useInlineRelatedMedia: $123d2ebc24e32906$var$useInlineRelatedMedia
};
var $123d2ebc24e32906$export$3e97b5ef32dc0192 = $kMqPq.nodeLimit;
 /* react Not a pure module */ 
});
parcelRegister("hgUzV", function(module, exports) {

$parcel$export(module.exports, "empty", function () { return $c92fd192f1fefd22$export$6e22c362a0406a2c; });
// Generated by ReScript, PLEASE EDIT WITH CARE
var $c92fd192f1fefd22$var$Layout = {};
var $c92fd192f1fefd22$export$ef82a0f75c4e1f89 = {
    Layout: $c92fd192f1fefd22$var$Layout
};
var $c92fd192f1fefd22$export$93c0382b74e40ff9 = {
    $$default: /* Md */ 4
};
var $c92fd192f1fefd22$export$a6c7ac8248d6e38a = {};
var $c92fd192f1fefd22$export$5fbe069c73ec3073 = {};
function $c92fd192f1fefd22$var$toString(sort) {
    switch(sort){
        case /* Default */ 0:
            return "default";
        case /* Newest */ 1:
            return "newest";
        case /* HighestPrice */ 2:
            return "highest_price";
        case /* LowestPrice */ 3:
            return "lowest_price";
        case /* BestSellers */ 4:
            return "best_sellers";
        case /* Featured */ 5:
            return "featured";
    }
}
var $c92fd192f1fefd22$export$f9b89e4f210f788a = {
    toString: $c92fd192f1fefd22$var$toString
};
var $c92fd192f1fefd22$export$9b7d2686799c37a = {};
var $c92fd192f1fefd22$export$6955bcca4cd3539f = {};
var $c92fd192f1fefd22$export$6e22c362a0406a2c = {
    id: "",
    title: "",
    description: undefined,
    showTitle: true,
    showDescription: true,
    visible: true,
    visibleInMenuBar: true,
    visibleInSectionList: true,
    visibleInParent: true,
    visibleInHeaderSlider: true,
    listPageActiveLayout: {
        TAG: /* SubCategoriesGrid */ 2,
        _0: {
            columns: /* FourColumnGrid */ 3,
            gap: /* Equal */ 0,
            maxRows: undefined,
            maxWidth: undefined,
            padding: undefined,
            pattern: undefined
        }
    },
    userSelectedLayout: {
        TAG: /* SubCategoriesGrid */ 2,
        _0: {
            columns: /* FourColumnGrid */ 3,
            gap: /* Equal */ 0,
            maxRows: undefined,
            maxWidth: undefined,
            padding: undefined,
            pattern: undefined
        }
    },
    forcedPLPLayout: {
        TAG: /* ProductGrid */ 3,
        _0: {
            columns: /* FourColumnGrid */ 3,
            gap: /* Equal */ 0,
            maxRows: undefined,
            maxWidth: undefined,
            padding: undefined,
            pattern: undefined
        }
    },
    tabbedSubCategories: undefined,
    card: {
        TAG: /* ImageLinkCard */ 0,
        _0: {
            link: {
                TAG: /* URL */ 0,
                _0: ""
            },
            imageUrl: "",
            size: /* Md */ 4,
            shape: /* Square */ 1
        }
    },
    categoryType: {
        TAG: /* Link */ 0,
        _0: {
            link: "",
            imageWidth: undefined,
            imageHeight: undefined
        }
    },
    socialNetworkSource: undefined,
    displayPriority: /* ChildrenFirst */ 0,
    expandVariantsInProductsListing: undefined,
    lastModifiedAt: undefined,
    sectionTheme: /* LegacyTheme */ 0,
    pageTheme: /* LegacyTheme */ 0,
    stickySection: false
};
 /* No side effect */ 
});


})();
//# sourceMappingURL=QuickViewOverlay.bs.185d9f67.js.map
